<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Header Section -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1 animate-fadeIn">
      <div class="w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest uppercase">Finanzas & Créditos</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Gestión de Créditos
          <span v-if="activeTab === 'cashea'" class="px-2 sm:px-3 py-0.5 bg-teal-100 dark:bg-teal-900/40 text-teal-600 dark:text-teal-300 text-xs sm:text-sm font-black rounded-lg border border-teal-200 dark:border-teal-800">
            Cobros Semanales
          </span>
          <span v-else class="px-2 sm:px-3 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-xs sm:text-sm font-black rounded-lg border border-indigo-200 dark:border-indigo-800">
            Empresa
          </span>
        </h1>
      </div>

      <div class="flex items-center gap-2 w-full sm:w-auto overflow-x-auto pb-1 custom-scrollbar">
        <!-- Botón WhatsApp -->
        <button
          v-if="activeTab === 'clientes' && clienteSeleccionadoWhatsapp"
          @click="abrirWhatsappCliente(clienteSeleccionadoWhatsapp)"
          class="flex items-center px-3 sm:px-4 py-1.5 sm:py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-xl transition-all duration-300 shadow-md hover:shadow-lg text-[10px] sm:text-sm font-black flex-shrink-0"
        >
          <Icon icon="mdi:whatsapp" class="mr-1 sm:mr-2 text-base sm:text-lg" />
          <span class="hidden sm:inline">WhatsApp</span>
        </button>

        <!-- Botón Exportar -->
        <div class="relative flex-shrink-0">
          <button
            @click="showExportMenu = !showExportMenu"
            class="flex items-center px-3 sm:px-4 py-1.5 sm:py-2.5 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-xl hover:from-purple-700 hover:to-indigo-700 transition-all duration-300 shadow-md hover:shadow-lg text-[10px] sm:text-sm font-black"
          >
            <Icon icon="mdi:file-export" class="mr-1 sm:mr-2 text-base sm:text-lg" />
            <span class="hidden sm:inline">Exportar</span>
            <Icon icon="mdi:chevron-down" class="ml-1 sm:ml-2" />
          </button>

          <!-- Menú Exportar -->
          <div v-if="showExportMenu"
               class="absolute right-0 mt-2 w-48 sm:w-56 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 z-50">
            <div class="py-1 sm:py-2">
              <button
                @click="exportToExcel"
                class="w-full px-3 sm:px-4 py-2 sm:py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs sm:text-sm"
              >
                <Icon icon="mdi:microsoft-excel" class="mr-2 sm:mr-3 text-green-600 text-base sm:text-xl" />
                <div>
                  <p class="font-medium">Exportar a Excel</p>
                  <p class="text-[9px] sm:text-xs text-gray-500">Todos los créditos</p>
                </div>
              </button>
              <button
                @click="exportToPDF"
                class="w-full px-3 sm:px-4 py-2 sm:py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs sm:text-sm"
              >
                <Icon icon="mdi:file-pdf-box" class="mr-2 sm:mr-3 text-red-600 text-base sm:text-xl" />
                <div>
                  <p class="font-medium">Exportar a PDF</p>
                  <p class="text-[9px] sm:text-xs text-gray-500">Reporte formal</p>
                </div>
              </button>
              <button
                @click="exportReporteCliente"
                class="w-full px-3 sm:px-4 py-2 sm:py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs sm:text-sm"
              >
                <Icon icon="mdi:account-group" class="mr-2 sm:mr-3 text-blue-600 text-base sm:text-xl" />
                <div>
                  <p class="font-medium">Reporte por Cliente</p>
                  <p class="text-[9px] sm:text-xs text-gray-500">Estado de cuenta</p>
                </div>
              </button>
              <div class="border-t border-gray-200 dark:border-gray-700 my-1 sm:my-2"></div>
              <button
                @click="triggerImport"
                class="w-full px-3 sm:px-4 py-2 sm:py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs sm:text-sm"
              >
                <Icon icon="mdi:import" class="mr-2 sm:mr-3 text-blue-600 text-base sm:text-xl" />
                <div>
                  <p class="font-medium">Importar Créditos</p>
                  <p class="text-[9px] sm:text-xs text-gray-500">Subir archivo .xlsx</p>
                </div>
              </button>
            </div>
          </div>
        </div>

        <!-- Cards resumen -->
        <div class="flex items-center gap-2 flex-shrink-0">
          <div class="bg-white dark:bg-gray-800 p-1.5 sm:p-2 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm flex items-center gap-2 sm:gap-4 px-2 sm:px-4">
            <div class="flex flex-col items-end">
              <span class="text-[8px] sm:text-[10px] font-black text-indigo-500 uppercase tracking-widest">Pendiente</span>
              <span class="text-sm sm:text-lg font-black text-indigo-600 dark:text-indigo-400">{{ formatCurrency(totalEmpresaPendiente) }}</span>
            </div>
            <div class="p-1 sm:p-2 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg">
              <Icon icon="mdi:office-building" class="text-indigo-600 text-base sm:text-xl" />
            </div>
          </div>

          <!-- Card Cashea: Neto Semanal -->
          <div
            class="bg-white dark:bg-gray-800 p-1.5 sm:p-2 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm flex items-center gap-2 sm:gap-4 px-2 sm:px-4 opacity-80 scale-95 origin-right cursor-help"
            :title="`Neto a recibir este miércoles: ${formatCurrency(totalCasheaPendiente)}\nDeuda total pendiente: ${formatCurrency(totalCasheaDeudaTotal)}`"
          >
            <div class="flex flex-col items-end">
              <span class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest">
                Cashea Semana
              </span>
              <span class="text-xs sm:text-base font-black text-teal-600">
                {{ formatCurrency(totalCasheaPendiente) }}
              </span>
              <span v-if="totalCuotasSemanal > 0" class="text-[7px] sm:text-[9px] font-bold text-gray-400 leading-none">
                {{ totalCuotasSemanal }} cuota(s)
              </span>
            </div>
            <div class="p-1 sm:p-2 bg-teal-50 dark:bg-teal-900/20 rounded-lg">
              <Icon icon="mdi:cellphone-check" class="text-teal-600 text-base sm:text-lg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Navigation -->
    <div class="flex items-center gap-1 sm:gap-2 mb-3 sm:mb-6 bg-white dark:bg-gray-800 p-1 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm w-full overflow-x-auto custom-scrollbar animate-fadeInUp">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        @click="activeTab = tab.id"
        :class="[
          'px-3 sm:px-6 py-1.5 sm:py-2.5 rounded-xl font-black text-[9px] sm:text-xs tracking-widest uppercase transition-all duration-300 flex items-center gap-1 sm:gap-2 whitespace-nowrap flex-shrink-0',
          activeTab === tab.id
            ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-500/30'
            : 'text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700'
        ]"
      >
        <Icon :icon="tab.icon" class="text-base sm:text-lg" />
        <span class="hidden xs:inline">{{ tab.name }}</span>
        <span class="xs:hidden">{{ tab.shortName || tab.name }}</span>
      </button>
    </div>

    <!-- Filters & Search -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-5 mb-3 sm:mb-5 animate-fadeInUp delay-100">
      <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 items-center">
        <div class="relative flex-1 w-full group">
          <Icon icon="mdi:magnify" class="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg sm:text-2xl group-focus-within:text-indigo-500 transition-colors" />
          <input
            v-model="filtroBusqueda"
            type="text"
            placeholder="Buscar por cliente, proveedor..."
            class="w-full pl-10 sm:pl-14 pr-3 sm:pr-4 py-2.5 sm:py-3.5 bg-gray-50 dark:bg-gray-900/50 border-2 border-gray-100 dark:border-gray-700 focus:border-indigo-500 focus:bg-white dark:focus:bg-gray-700 rounded-2xl transition-all duration-300 outline-none dark:text-white font-bold text-sm sm:text-base"
          />
        </div>
        <div class="flex items-center gap-2 w-full sm:w-auto flex-shrink-0">
          <button
            @click="cargarDatos"
            class="px-3 sm:px-6 py-2.5 sm:py-3.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-2xl font-black text-[10px] sm:text-xs tracking-widest hover:bg-gray-200 dark:hover:bg-gray-600 transition-all flex items-center gap-2 border border-gray-200 dark:border-gray-600 flex-1 sm:flex-none justify-center"
          >
            <Icon icon="mdi:refresh" :class="{'animate-spin': loading}" class="text-lg sm:text-xl" />
            <span class="hidden sm:inline">Refrescar</span>
          </button>
          <button
            v-if="activeTab === 'cashea'"
            @click="cargarPagoSemanalCashea"
            class="px-3 sm:px-6 py-2.5 sm:py-3.5 bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300 rounded-2xl font-black text-[10px] sm:text-xs tracking-widest hover:bg-teal-200 transition-all flex items-center gap-2 border border-teal-200 dark:border-teal-800 flex-1 sm:flex-none justify-center"
          >
            <Icon icon="mdi:calendar-week" :class="{'animate-spin': loadingPagoSemanal}" class="text-lg sm:text-xl" />
            <span class="hidden sm:inline">Cargar Semana</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ========== VERSIÓN MÓVIL - TARJETAS AGRUPADAS POR TIPO ========== -->
    <div v-if="activeTab === 'empresa'" class="lg:hidden space-y-4 animate-fadeInUp delay-200">
      <div v-if="loading" v-for="i in 3" :key="'load-mobile-'+i" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 animate-pulse">
        <div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-3/4 mb-2"></div>
        <div class="h-3 bg-gray-100 dark:bg-gray-700 rounded w-1/2"></div>
      </div>

      <!-- Ventas -->
      <div v-if="!loading && ventasEmpresa.length > 0" class="space-y-3">
        <div class="flex items-center justify-between bg-indigo-50 dark:bg-indigo-900/20 px-3 py-2 rounded-xl border border-indigo-100 dark:border-indigo-800">
          <div class="flex items-center gap-2">
            <Icon icon="mdi:cart-arrow-down" class="text-indigo-600 text-lg" />
            <h3 class="text-xs font-black text-indigo-700 dark:text-indigo-300 uppercase tracking-widest">Ventas</h3>
          </div>
          <span class="text-[10px] font-black text-indigo-600 dark:text-indigo-400 bg-white dark:bg-gray-800 px-2 py-0.5 rounded-lg">{{ ventasEmpresa.length }} registros</span>
        </div>
        <div v-for="item in paginadoVentas" :key="'v-' + item.id"
             @click="abrirDetalles(item)"
             class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-all duration-200 cursor-pointer">
          <div class="flex items-center justify-between mb-2 pb-2 border-b border-gray-100 dark:border-gray-700">
            <div class="flex items-center gap-2">
              <div class="w-8 h-8 rounded-xl flex items-center justify-center shadow-sm border bg-indigo-50 text-indigo-600 border-indigo-100 dark:bg-indigo-900/30 dark:border-indigo-800">
                <Icon icon="mdi:cart-arrow-down" class="text-lg" />
              </div>
              <div>
                <span class="font-black text-gray-900 dark:text-white text-sm">#{{ item.referencia }}</span>
                <p class="text-[8px] font-black text-gray-400 uppercase tracking-widest">{{ item.tipo }}</p>
              </div>
            </div>
            <span class="text-[10px] font-black text-gray-400">{{ diasTranscurridos(item.fecha) }} días</span>
          </div>

          <div class="grid grid-cols-2 gap-2 text-sm">
            <div>
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Entidad</p>
              <p class="font-bold text-gray-700 dark:text-gray-200 truncate">{{ item.entidad }}</p>
            </div>
            <div class="text-right">
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Fecha</p>
              <p class="font-bold text-gray-700 dark:text-gray-200">{{ formatearFecha(item.fecha) }}</p>
            </div>
          </div>

          <div class="flex items-center justify-between mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
            <div>
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Saldo Pendiente</p>
              <span class="text-base font-black text-indigo-500">{{ formatCurrency(item.saldo) }}</span>
            </div>
            <div class="flex items-center gap-1.5">
              <button
                v-if="obtenerTelefonoDesdeItem(item)"
                @click.stop="abrirWhatsappDesdeItem(item)"
                class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-xl hover:bg-green-600 hover:text-white transition-all shadow-sm"
                title="WhatsApp"
              >
                <Icon icon="mdi:whatsapp" class="text-base" />
              </button>
              <button
                @click.stop="abrirModalPago(item)"
                class="px-3 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[9px] uppercase tracking-widest transition-all shadow-md shadow-indigo-500/20 flex items-center gap-1.5"
              >
                <Icon icon="mdi:cash-register" class="text-sm" />
                Cobrar
              </button>
            </div>
          </div>
        </div>

        <div v-if="totalPaginasVentas > 1" class="flex items-center justify-between bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-2">
          <button
            @click="paginaVentas = Math.max(1, paginaVentas - 1)"
            :disabled="paginaVentas === 1"
            class="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-lg font-black text-[9px] uppercase tracking-widest hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-1"
          >
            <Icon icon="mdi:chevron-left" class="text-sm" />
            Ant.
          </button>
          <span class="text-[10px] font-black text-gray-500 dark:text-gray-400">
            {{ paginaVentas }} / {{ totalPaginasVentas }}
          </span>
          <button
            @click="paginaVentas = Math.min(totalPaginasVentas, paginaVentas + 1)"
            :disabled="paginaVentas === totalPaginasVentas"
            class="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-lg font-black text-[9px] uppercase tracking-widest hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-1"
          >
            Sig.
            <Icon icon="mdi:chevron-right" class="text-sm" />
          </button>
        </div>
      </div>

      <!-- Reparaciones -->
      <div v-if="!loading && reparacionesEmpresa.length > 0" class="space-y-3">
        <div class="flex items-center justify-between bg-emerald-50 dark:bg-emerald-900/20 px-3 py-2 rounded-xl border border-emerald-100 dark:border-emerald-800">
          <div class="flex items-center gap-2">
            <Icon icon="mdi:tools" class="text-emerald-600 text-lg" />
            <h3 class="text-xs font-black text-emerald-700 dark:text-emerald-300 uppercase tracking-widest">Reparaciones</h3>
          </div>
          <span class="text-[10px] font-black text-emerald-600 dark:text-emerald-400 bg-white dark:bg-gray-800 px-2 py-0.5 rounded-lg">{{ reparacionesEmpresa.length }} registros</span>
        </div>
        <div v-for="item in paginadoReparaciones" :key="'r-' + item.id"
             @click="abrirDetalles(item)"
             class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-all duration-200 cursor-pointer">
          <div class="flex items-center justify-between mb-2 pb-2 border-b border-gray-100 dark:border-gray-700">
            <div class="flex items-center gap-2">
              <div class="w-8 h-8 rounded-xl flex items-center justify-center shadow-sm border bg-emerald-50 text-emerald-600 border-emerald-100 dark:bg-emerald-900/30 dark:border-emerald-800">
                <Icon icon="mdi:tools" class="text-lg" />
              </div>
              <div>
                <span class="font-black text-gray-900 dark:text-white text-sm">#{{ item.referencia }}</span>
                <p class="text-[8px] font-black text-gray-400 uppercase tracking-widest">{{ item.tipo }}</p>
              </div>
            </div>
            <span class="text-[10px] font-black text-gray-400">{{ diasTranscurridos(item.fecha) }} días</span>
          </div>

          <div class="grid grid-cols-2 gap-2 text-sm">
            <div>
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Entidad</p>
              <p class="font-bold text-gray-700 dark:text-gray-200 truncate">{{ item.entidad }}</p>
            </div>
            <div class="text-right">
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Fecha</p>
              <p class="font-bold text-gray-700 dark:text-gray-200">{{ formatearFecha(item.fecha) }}</p>
            </div>
          </div>

          <div class="flex items-center justify-between mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
            <div>
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Saldo Pendiente</p>
              <span class="text-base font-black text-emerald-500">{{ formatCurrency(item.saldo) }}</span>
            </div>
            <div class="flex items-center gap-1.5">
              <button
                v-if="obtenerTelefonoDesdeItem(item)"
                @click.stop="abrirWhatsappDesdeItem(item)"
                class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-xl hover:bg-green-600 hover:text-white transition-all shadow-sm"
                title="WhatsApp"
              >
                <Icon icon="mdi:whatsapp" class="text-base" />
              </button>
              <button
                @click.stop="abrirModalPago(item)"
                class="px-3 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-black text-[9px] uppercase tracking-widest transition-all shadow-md shadow-emerald-500/20 flex items-center gap-1.5"
              >
                <Icon icon="mdi:cash-register" class="text-sm" />
                Cobrar
              </button>
            </div>
          </div>
        </div>

        <div v-if="totalPaginasReparaciones > 1" class="flex items-center justify-between bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-2">
          <button
            @click="paginaReparaciones = Math.max(1, paginaReparaciones - 1)"
            :disabled="paginaReparaciones === 1"
            class="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-lg font-black text-[9px] uppercase tracking-widest hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-1"
          >
            <Icon icon="mdi:chevron-left" class="text-sm" />
            Ant.
          </button>
          <span class="text-[10px] font-black text-gray-500 dark:text-gray-400">
            {{ paginaReparaciones }} / {{ totalPaginasReparaciones }}
          </span>
          <button
            @click="paginaReparaciones = Math.min(totalPaginasReparaciones, paginaReparaciones + 1)"
            :disabled="paginaReparaciones === totalPaginasReparaciones"
            class="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-lg font-black text-[9px] uppercase tracking-widest hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-1"
          >
            Sig.
            <Icon icon="mdi:chevron-right" class="text-sm" />
          </button>
        </div>
      </div>

      <!-- Servicios Externos -->
      <div v-if="!loading && serviciosExternosEmpresa.length > 0" class="space-y-3">
        <div class="flex items-center justify-between bg-cyan-50 dark:bg-cyan-900/20 px-3 py-2 rounded-xl border border-cyan-100 dark:border-cyan-800">
          <div class="flex items-center gap-2">
            <Icon icon="mdi:home-wrench" class="text-cyan-600 text-lg" />
            <h3 class="text-xs font-black text-cyan-700 dark:text-cyan-300 uppercase tracking-widest">Servicios Externos</h3>
          </div>
          <span class="text-[10px] font-black text-cyan-600 dark:text-cyan-400 bg-white dark:bg-gray-800 px-2 py-0.5 rounded-lg">{{ serviciosExternosEmpresa.length }} registros</span>
        </div>
        <div v-for="item in paginadoServiciosExternos" :key="'se-' + item.id"
             @click="abrirDetalles(item)"
             class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-all duration-200 cursor-pointer">
          <div class="flex items-center justify-between mb-2 pb-2 border-b border-gray-100 dark:border-gray-700">
            <div class="flex items-center gap-2">
              <div class="w-8 h-8 rounded-xl flex items-center justify-center shadow-sm border bg-cyan-50 text-cyan-600 border-cyan-100 dark:bg-cyan-900/30 dark:border-cyan-800">
                <Icon icon="mdi:home-wrench" class="text-lg" />
              </div>
              <div>
                <span class="font-black text-gray-900 dark:text-white text-sm">#{{ item.referencia }}</span>
                <p class="text-[8px] font-black text-gray-400 uppercase tracking-widest">{{ item.tipo }}</p>
              </div>
            </div>
            <span class="text-[10px] font-black text-gray-400">{{ diasTranscurridos(item.fecha) }} días</span>
          </div>

          <div class="grid grid-cols-2 gap-2 text-sm">
            <div>
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Entidad</p>
              <p class="font-bold text-gray-700 dark:text-gray-200 truncate">{{ item.entidad }}</p>
            </div>
            <div class="text-right">
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Fecha</p>
              <p class="font-bold text-gray-700 dark:text-gray-200">{{ formatearFecha(item.fecha) }}</p>
            </div>
          </div>

          <div class="flex items-center justify-between mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
            <div>
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Saldo Pendiente</p>
              <span class="text-base font-black text-cyan-500">{{ formatCurrency(item.saldo) }}</span>
            </div>
            <div class="flex items-center gap-1.5">
              <button
                v-if="obtenerTelefonoDesdeItem(item)"
                @click.stop="abrirWhatsappDesdeItem(item)"
                class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-xl hover:bg-green-600 hover:text-white transition-all shadow-sm"
                title="WhatsApp"
              >
                <Icon icon="mdi:whatsapp" class="text-base" />
              </button>
              <button
                @click.stop="abrirModalPago(item)"
                class="px-3 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl font-black text-[9px] uppercase tracking-widest transition-all shadow-md shadow-cyan-500/20 flex items-center gap-1.5"
              >
                <Icon icon="mdi:cash-register" class="text-sm" />
                Cobrar
              </button>
            </div>
          </div>
        </div>

        <div v-if="totalPaginasServiciosExternos > 1" class="flex items-center justify-between bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-2">
          <button
            @click="paginaServiciosExternos = Math.max(1, paginaServiciosExternos - 1)"
            :disabled="paginaServiciosExternos === 1"
            class="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-lg font-black text-[9px] uppercase tracking-widest hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-1"
          >
            <Icon icon="mdi:chevron-left" class="text-sm" />
            Ant.
          </button>
          <span class="text-[10px] font-black text-gray-500 dark:text-gray-400">
            {{ paginaServiciosExternos }} / {{ totalPaginasServiciosExternos }}
          </span>
          <button
            @click="paginaServiciosExternos = Math.min(totalPaginasServiciosExternos, paginaServiciosExternos + 1)"
            :disabled="paginaServiciosExternos === totalPaginasServiciosExternos"
            class="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-lg font-black text-[9px] uppercase tracking-widest hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-1"
          >
            Sig.
            <Icon icon="mdi:chevron-right" class="text-sm" />
          </button>
        </div>
      </div>

      <div v-if="!loading && listadoFiltrado.length === 0" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-8 text-center">
        <div class="flex flex-col items-center opacity-30 select-none">
          <Icon icon="mdi:cash-remove" class="text-6xl mb-3" />
          <h4 class="text-lg font-black text-gray-400 tracking-widest">No hay créditos pendientes</h4>
        </div>
      </div>
    </div>

    <!-- ========== VERSIÓN MÓVIL - CASHEA ========== -->
    <div v-else-if="activeTab === 'cashea'" class="animate-fadeIn space-y-3">
      <!-- Panel de liquidación semanal -->
      <div class="grid grid-cols-1 gap-3">
        <div class="bg-white dark:bg-gray-800 rounded-2xl p-4 border border-gray-200 dark:border-gray-700 shadow-sm flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-12 h-12 bg-teal-500 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-teal-500/30">
              <Icon icon="mdi:bank-transfer" class="text-2xl" />
            </div>
            <div>
              <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest">Neto a Recibir</p>
              <p class="text-2xl font-black text-teal-600 leading-none">
                {{ formatCurrency(totalCasheaPendiente) }}
              </p>
              <p class="text-[9px] font-bold text-gray-500">
                {{ pagoSemanalCashea 
                    ? `${pagoSemanalCashea.cantidadCreditos} créditos · ${pagoSemanalCashea.cantidadCuotas} cuotas` 
                    : 'Sin datos cargados' }}
              </p>
              <p class="text-[8px] font-bold text-gray-400 mt-0.5">
                Deuda total: {{ formatCurrency(totalCasheaDeudaTotal) }}
              </p>
            </div>
          </div>
          <button
            @click="abrirLiquidacionMasiva"
            :disabled="!pagoSemanalCashea || pagoSemanalCashea.cantidadCreditos === 0"
            class="px-3 py-2 bg-teal-600 hover:bg-teal-700 disabled:opacity-50 text-white rounded-xl font-black text-[9px] uppercase tracking-widest transition-all shadow-xl shadow-teal-500/20 flex items-center gap-1.5"
          >
            <Icon icon="mdi:check-all" class="text-base" />
            <span class="hidden xs:inline">Facturar</span>
          </button>
        </div>

        <div v-if="pagoSemanalCashea" class="bg-indigo-600 rounded-2xl p-4 text-white shadow-xl shadow-indigo-500/20">
          <div class="flex items-center justify-between mb-1">
            <div>
              <p class="text-[9px] font-black text-indigo-200 uppercase tracking-widest">Miércoles de Pago</p>
              <p class="text-base font-bold">{{ pagoSemanalCashea.fechaPagoFormateada }}</p>
            </div>
            <div class="flex items-center gap-1">
              <button
                @click="cambiarMiercoles(-1)"
                class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all"
                title="Miércoles anterior"
              >
                <Icon icon="mdi:chevron-left" class="text-lg" />
              </button>
              <button
                @click="cambiarMiercoles(1)"
                class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all"
                title="Miércoles siguiente"
              >
                <Icon icon="mdi:chevron-right" class="text-lg" />
              </button>
            </div>
          </div>
          <p class="text-xs text-indigo-100 opacity-80">
            Bruto: {{ formatCurrency(pagoSemanalCashea.totalBruto) }} ·
            Comisión {{ pagoSemanalCashea.porcentajeComision }}%:
            {{ formatCurrency(pagoSemanalCashea.descuentoComision) }}
          </p>
        </div>
      </div>

      <!-- Resumen móvil del detalle semanal -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 overflow-hidden shadow-sm">
        <div class="p-3 border-b border-gray-100 dark:border-gray-700 flex justify-between items-center">
          <h4 class="text-[10px] font-black text-gray-400 uppercase tracking-widest">Detalle de Cobros</h4>
          <button
            @click="exportCasheaToExcel"
            class="px-2 py-1 bg-teal-50 dark:bg-teal-900/30 text-teal-600 dark:text-teal-400 rounded-lg font-black text-[8px] uppercase tracking-widest hover:bg-teal-100 transition-all flex items-center gap-1"
          >
            <Icon icon="mdi:file-excel" class="text-sm" />
            Exportar
          </button>
        </div>

        <div v-if="loadingPagoSemanal" class="p-4 text-center">
          <Icon icon="mdi:loading" class="animate-spin text-3xl text-teal-500" />
        </div>

        <div v-else-if="!pagoSemanalCashea || pagoSemanalCashea.detalle.length === 0" class="p-8 text-center">
          <Icon icon="mdi:cellphone-off" class="text-5xl text-gray-200 mb-2" />
          <p class="text-xs font-black text-gray-400 uppercase tracking-widest">Sin cobros esta semana</p>
        </div>

        <div v-else class="max-h-[500px] overflow-y-auto custom-scrollbar divide-y divide-gray-100 dark:divide-gray-700">
          <div v-for="credito in pagoSemanalCashea.detalle" :key="credito.origen + '-' + credito.idCreditoPadre" class="p-3">
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center gap-2">
                <div :class="[
                  'w-8 h-8 rounded-xl flex items-center justify-center',
                  credito.origen === 'Venta'
                    ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30'
                    : 'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30'
                ]">
                  <Icon :icon="credito.origen === 'Venta' ? 'mdi:cart-arrow-down' : 'mdi:tools'" class="text-base" />
                </div>
                <div>
                  <p class="font-black text-gray-900 dark:text-white text-xs">#{{ credito.numeroFactura }}</p>
                  <p class="text-[9px] font-bold text-gray-500 truncate">{{ credito.cliente }}</p>
                </div>
              </div>
              <div class="text-right">
                <p class="font-black text-teal-600 text-sm">{{ formatCurrency(credito.montoTotalCuotas) }}</p>
                <p class="text-[8px] font-black text-gray-400">{{ credito.cantidadCuotas }} cuota(s)</p>
              </div>
            </div>
            <div class="bg-gray-50 dark:bg-gray-900/40 rounded-xl p-2 space-y-1">
              <div v-for="cuota in credito.cuotas" :key="cuota.idCuota" class="flex items-center justify-between text-[10px]">
                <span class="font-bold text-gray-500">
                  Cuota #{{ cuota.numeroCuota }} · Vence {{ formatearFecha(cuota.fechaVencimiento) }}
                </span>
                <span class="font-black text-teal-600">{{ formatCurrency(cuota.montoUsd) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== VERSIÓN MÓVIL - CLIENTES ========== -->
    <div v-else-if="activeTab === 'clientes'" class="animate-fadeIn">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div class="p-3 border-b border-gray-100 dark:border-gray-700">
          <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
            <h4 class="text-xs font-black text-gray-900 dark:text-white uppercase tracking-widest">Estado de Cuenta por Cliente</h4>
            <div class="flex items-center gap-2 w-full sm:w-auto flex-wrap">
              <div class="flex-1 sm:flex-none">
                <select
                  v-model="clienteSeleccionadoWhatsapp"
                  class="w-full px-2 py-1.5 bg-green-50 dark:bg-green-900/30 border-2 border-green-200 dark:border-green-800 rounded-xl font-black text-[9px] outline-none"
                >
                  <option value="">Seleccionar...</option>
                  <option v-for="cliente in resumenPorCliente" :key="cliente.entidad" :value="cliente">
                    {{ cliente.entidad }} ({{ formatCurrency(cliente.totalDeuda) }})
                  </option>
                </select>
              </div>
              <button
                v-if="clienteSeleccionadoWhatsapp"
                @click="abrirWhatsappCliente(clienteSeleccionadoWhatsapp)"
                class="px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded-xl font-black text-[9px] uppercase tracking-widest transition-all flex items-center gap-1 shadow-lg shadow-green-500/20 flex-shrink-0"
              >
                <Icon icon="mdi:whatsapp" class="text-base" />
                <span class="hidden xs:inline">Enviar</span>
              </button>
              <button
                @click="imprimirReportePorCliente(resumenPorCliente)"
                class="px-3 py-1.5 bg-gray-900 text-white rounded-xl font-black text-[9px] uppercase tracking-widest hover:bg-black transition-all flex items-center gap-1 shadow-lg flex-shrink-0"
              >
                <Icon icon="mdi:printer" class="text-base" />
                <span class="hidden xs:inline">Imprimir</span>
              </button>
            </div>
          </div>
        </div>

        <div class="divide-y divide-gray-100 dark:divide-gray-700">
          <div v-if="resumenPorCliente.length === 0" class="p-8 text-center text-gray-400 font-bold">
            No hay clientes con deuda pendiente.
          </div>
          <template v-for="cliente in resumenPorCliente" :key="cliente.entidad">
            <div class="hover:bg-indigo-50/30 dark:hover:bg-gray-700/30 transition-all">
              <div class="p-3 flex items-center justify-between cursor-pointer" @click="toggleCliente(cliente.entidad)">
                <div class="flex items-center gap-2">
                  <div class="w-7 h-7 rounded-full bg-indigo-100 dark:bg-indigo-900/50 flex items-center justify-center text-indigo-600 text-sm">
                    <Icon :icon="isClienteExpanded(cliente.entidad) ? 'mdi:chevron-down' : 'mdi:chevron-right'" />
                  </div>
                  <span class="font-bold text-gray-900 dark:text-white text-sm">{{ cliente.entidad }}</span>
                </div>
                <span class="font-black text-rose-500 text-sm">{{ formatCurrency(cliente.totalDeuda) }}</span>
              </div>

              <div v-if="isClienteExpanded(cliente.entidad)" class="bg-gray-50/80 dark:bg-gray-900/40 p-3 border-l-4 border-indigo-500 ml-4 mb-2 rounded-r-xl">
                <div class="space-y-2">
                  <div class="flex justify-between text-xs">
                    <span class="text-gray-500">Ventas:</span>
                    <span class="font-bold text-gray-700 dark:text-gray-300">{{ formatCurrency(cliente.deudaVentas) }}</span>
                  </div>
                  <div class="flex justify-between text-xs">
                    <span class="text-gray-500">Reparaciones:</span>
                    <span class="font-bold text-gray-700 dark:text-gray-300">{{ formatCurrency(cliente.deudaReparaciones) }}</span>
                  </div>
                  <div class="border-t border-gray-200 dark:border-gray-700 pt-2 mt-1">
                    <div v-for="detalle in cliente.detalles" :key="detalle.tipo + detalle.id"
                         @click="abrirDetalles(detalle)"
                         class="flex items-center justify-between py-1.5 hover:bg-gray-50 dark:hover:bg-gray-700/20 px-2 rounded-lg transition-colors">
                      <div class="flex items-center gap-2">
                        <span class="text-[10px] font-bold text-gray-600">#{{ detalle.referencia }}</span>
                        <span :class="[
                          'px-1.5 py-0.5 rounded-full font-black text-[7px] uppercase',
                          detalle.tipo === 'Venta' ? 'bg-indigo-50 text-indigo-600' : 'bg-teal-50 text-teal-600'
                        ]">{{ detalle.tipo }}</span>
                      </div>
                      <div class="flex items-center gap-1.5">
                        <span class="text-[10px] font-black text-rose-500">{{ formatCurrency(detalle.saldo) }}</span>
                        <button
                          v-if="obtenerTelefonoDesdeItem(detalle)"
                          @click.stop="abrirWhatsappDesdeItem(detalle)"
                          class="p-0.5 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded hover:bg-green-600 hover:text-white transition-all"
                        >
                          <Icon icon="mdi:whatsapp" class="text-sm" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- ========== VERSIÓN MÓVIL - REPORTES ========== -->
    <div v-else-if="activeTab === 'reportes'" class="space-y-3 animate-fadeIn">
      <div class="flex justify-between items-center mb-2 print:hidden">
        <h3 class="text-xs font-black text-gray-500 uppercase tracking-widest">Resumen de Cartera</h3>
        <div class="flex items-center gap-1.5">
          <button
            @click="exportReportesToExcel"
            class="px-2 py-1.5 bg-green-600 text-white rounded-xl font-black text-[8px] uppercase tracking-widest hover:bg-green-700 transition-all flex items-center gap-1 shadow-lg"
          >
            <Icon icon="mdi:file-excel" class="text-sm" />
            <span class="hidden xs:inline">Excel</span>
          </button>
          <button
            @click="imprimirReporteCreditos(datos, statsReporte)"
            class="px-2 py-1.5 bg-gray-900 text-white rounded-xl font-black text-[8px] uppercase tracking-widest hover:bg-black transition-all flex items-center gap-1 shadow-lg"
          >
            <Icon icon="mdi:printer" class="text-sm" />
            <span class="hidden xs:inline">Imprimir</span>
          </button>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-2">
        <div class="bg-white dark:bg-gray-800 p-3 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm">
          <div class="flex items-center gap-2 mb-1">
            <div class="p-1.5 bg-indigo-50 dark:bg-indigo-900/30 rounded-xl">
              <Icon icon="mdi:cash-multiple" class="text-indigo-600 text-lg" />
            </div>
            <span class="text-[8px] font-black text-gray-400 uppercase tracking-widest">Total</span>
          </div>
          <h4 class="text-lg font-black text-gray-900 dark:text-white">{{ formatCurrency(statsReporte.totalPendiente) }}</h4>
        </div>

        <div class="bg-white dark:bg-gray-800 p-3 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm">
          <div class="flex items-center gap-2 mb-1">
            <div class="p-1.5 bg-emerald-50 dark:bg-emerald-900/30 rounded-xl">
              <Icon icon="mdi:check-decagram" class="text-emerald-600 text-lg" />
            </div>
            <span class="text-[8px] font-black text-gray-400 uppercase tracking-widest">Recuperado</span>
          </div>
          <h4 class="text-lg font-black text-emerald-600">{{ statsReporte.porcentajeCobrado.toFixed(1) }}%</h4>
          <div class="w-full h-1 bg-gray-100 dark:bg-gray-700 rounded-full mt-1 overflow-hidden">
            <div class="h-full bg-emerald-500 rounded-full" :style="{ width: statsReporte.porcentajeCobrado + '%' }"></div>
          </div>
        </div>

        <div class="bg-white dark:bg-gray-800 p-3 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm col-span-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <div class="p-1.5 bg-indigo-50 dark:bg-indigo-900/30 rounded-xl">
                <Icon icon="mdi:office-building" class="text-indigo-600 text-lg" />
              </div>
              <div>
                <span class="text-[8px] font-black text-gray-400 uppercase tracking-widest">Empresa</span>
                <p class="text-sm font-black text-indigo-600">{{ formatCurrency(statsReporte.montoEmpresa) }}</p>
              </div>
            </div>
            <div class="text-right">
              <span class="text-[8px] font-black text-gray-400 uppercase tracking-widest">Registros</span>
              <p class="text-sm font-black text-gray-700">{{ statsReporte.countEmpresa }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden">
        <div class="p-3 border-b border-gray-100 dark:border-gray-700">
          <h4 class="text-xs font-black text-gray-900 dark:text-white uppercase tracking-widest">Próximos Vencimientos</h4>
        </div>
        <div v-for="i in statsReporte.proximosVencimientos" :key="i.id"
             class="flex items-center justify-between p-3 border-b border-gray-50 dark:border-gray-700/50">
          <div>
            <p class="font-bold text-gray-900 dark:text-white text-sm">{{ i.entidad }}</p>
            <p class="text-[9px] font-black text-gray-400">{{ formatearFecha(i.fecha) }}</p>
          </div>
          <span class="font-black text-rose-500">{{ formatCurrency(i.saldo) }}</span>
        </div>
      </div>
    </div>

    <!-- ========== VERSIÓN DESKTOP - TABLA AGRUPADA POR TIPO ========== -->
    <div v-if="activeTab === 'empresa'" class="hidden lg:block space-y-4 animate-fadeInUp delay-200">

      <!-- Tabla de Ventas -->
      <div v-if="ventasEmpresa.length > 0" class="bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div class="px-6 py-4 bg-indigo-50 dark:bg-indigo-900/20 border-b border-indigo-100 dark:border-indigo-800 flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-lg shadow-indigo-500/30">
              <Icon icon="mdi:cart-arrow-down" class="text-xl" />
            </div>
            <div>
              <h3 class="text-base font-black text-indigo-700 dark:text-indigo-300 uppercase tracking-widest">Ventas</h3>
              <p class="text-[10px] font-bold text-indigo-500 dark:text-indigo-400">{{ ventasEmpresa.length }} registros pendientes</p>
            </div>
          </div>
          <span class="text-lg font-black text-indigo-600 dark:text-indigo-400">
            {{ formatCurrency(ventasEmpresa.reduce((s, i) => s + (i.saldo || 0), 0)) }}
          </span>
        </div>
        <div class="overflow-x-auto custom-scrollbar">
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Referencia</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Cliente</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Fecha</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Monto Total</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Saldo Pendiente</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Acciones</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
              <tr v-for="item in paginadoVentas" :key="'vd-' + item.id" @click="abrirDetalles(item)" class="hover:bg-indigo-50/30 dark:hover:bg-gray-700/30 transition-all group cursor-pointer">
                <td class="px-6 py-5">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl flex items-center justify-center shadow-sm border bg-indigo-50 text-indigo-600 border-indigo-100 dark:bg-indigo-900/30 dark:border-indigo-800">
                      <Icon icon="mdi:cart-arrow-down" class="text-xl" />
                    </div>
                    <div>
                      <span class="font-black text-gray-900 dark:text-white text-sm">#{{ item.referencia }}</span>
                      <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest">{{ item.tipo }}</p>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-5">
                  <span class="font-bold text-gray-700 dark:text-gray-200 text-sm">{{ item.entidad }}</span>
                </td>
                <td class="px-6 py-5 whitespace-nowrap">
                  <div class="flex flex-col">
                    <span class="font-bold text-gray-700 dark:text-gray-200 text-sm">{{ formatearFecha(item.fecha) }}</span>
                    <span class="text-[10px] font-black text-gray-400 uppercase tracking-widest">{{ diasTranscurridos(item.fecha) }} días</span>
                  </div>
                </td>
                <td class="px-6 py-5">
                  <span class="font-black text-gray-400 text-sm line-through opacity-50">{{ formatCurrency(item.montoTotal) }}</span>
                </td>
                <td class="px-6 py-5">
                  <span class="text-lg font-black text-indigo-500">{{ formatCurrency(item.saldo) }}</span>
                </td>
                <td class="px-6 py-5">
                  <div class="flex justify-center gap-2">
                    <button
                      v-if="obtenerTelefonoDesdeItem(item)"
                      @click.stop="abrirWhatsappDesdeItem(item)"
                      class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-xl hover:bg-green-600 hover:text-white transition-all shadow-sm"
                      title="Enviar mensaje por WhatsApp"
                    >
                      <Icon icon="mdi:whatsapp" class="text-lg" />
                    </button>
                    <button
                      @click.stop="abrirModalPago(item)"
                      class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] uppercase tracking-widest transition-all shadow-md shadow-indigo-500/20 flex items-center gap-2"
                    >
                      <Icon icon="mdi:cash-register" class="text-base" />
                      Cobrar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="totalPaginasVentas > 1" class="flex justify-between items-center px-6 py-4 bg-gray-50 dark:bg-gray-900/50 border-t border-gray-200 dark:border-gray-700">
          <button
            @click="paginaVentas = Math.max(1, paginaVentas - 1)"
            :disabled="paginaVentas === 1"
            class="px-4 py-2 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 border border-gray-200 dark:border-gray-600"
          >
            <Icon icon="mdi:chevron-left" class="text-base" />
            Anterior
          </button>
          <span class="text-xs font-black text-gray-500 dark:text-gray-400">
            Página {{ paginaVentas }} de {{ totalPaginasVentas }} · {{ ventasEmpresa.length }} registros
          </span>
          <button
            @click="paginaVentas = Math.min(totalPaginasVentas, paginaVentas + 1)"
            :disabled="paginaVentas === totalPaginasVentas"
            class="px-4 py-2 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 border border-gray-200 dark:border-gray-600"
          >
            Siguiente
            <Icon icon="mdi:chevron-right" class="text-base" />
          </button>
        </div>
      </div>

      <!-- Tabla de Reparaciones -->
      <div v-if="reparacionesEmpresa.length > 0" class="bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div class="px-6 py-4 bg-emerald-50 dark:bg-emerald-900/20 border-b border-emerald-100 dark:border-emerald-800 flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center text-white shadow-lg shadow-emerald-500/30">
              <Icon icon="mdi:tools" class="text-xl" />
            </div>
            <div>
              <h3 class="text-base font-black text-emerald-700 dark:text-emerald-300 uppercase tracking-widest">Reparaciones</h3>
              <p class="text-[10px] font-bold text-emerald-500 dark:text-emerald-400">{{ reparacionesEmpresa.length }} registros pendientes</p>
            </div>
          </div>
          <span class="text-lg font-black text-emerald-600 dark:text-emerald-400">
            {{ formatCurrency(reparacionesEmpresa.reduce((s, i) => s + (i.saldo || 0), 0)) }}
          </span>
        </div>
        <div class="overflow-x-auto custom-scrollbar">
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Referencia</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Cliente</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Fecha</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Monto Total</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Saldo Pendiente</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Acciones</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
              <tr v-for="item in paginadoReparaciones" :key="'rd-' + item.id" @click="abrirDetalles(item)" class="hover:bg-emerald-50/30 dark:hover:bg-gray-700/30 transition-all group cursor-pointer">
                <td class="px-6 py-5">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl flex items-center justify-center shadow-sm border bg-emerald-50 text-emerald-600 border-emerald-100 dark:bg-emerald-900/30 dark:border-emerald-800">
                      <Icon icon="mdi:tools" class="text-xl" />
                    </div>
                    <div>
                      <span class="font-black text-gray-900 dark:text-white text-sm">#{{ item.referencia }}</span>
                      <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest">{{ item.tipo }}</p>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-5">
                  <span class="font-bold text-gray-700 dark:text-gray-200 text-sm">{{ item.entidad }}</span>
                </td>
                <td class="px-6 py-5 whitespace-nowrap">
                  <div class="flex flex-col">
                    <span class="font-bold text-gray-700 dark:text-gray-200 text-sm">{{ formatearFecha(item.fecha) }}</span>
                    <span class="text-[10px] font-black text-gray-400 uppercase tracking-widest">{{ diasTranscurridos(item.fecha) }} días</span>
                  </div>
                </td>
                <td class="px-6 py-5">
                  <span class="font-black text-gray-400 text-sm line-through opacity-50">{{ formatCurrency(item.montoTotal) }}</span>
                </td>
                <td class="px-6 py-5">
                  <span class="text-lg font-black text-emerald-500">{{ formatCurrency(item.saldo) }}</span>
                </td>
                <td class="px-6 py-5">
                  <div class="flex justify-center gap-2">
                    <button
                      v-if="obtenerTelefonoDesdeItem(item)"
                      @click.stop="abrirWhatsappDesdeItem(item)"
                      class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-xl hover:bg-green-600 hover:text-white transition-all shadow-sm"
                      title="Enviar mensaje por WhatsApp"
                    >
                      <Icon icon="mdi:whatsapp" class="text-lg" />
                    </button>
                    <button
                      @click.stop="abrirModalPago(item)"
                      class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-black text-[10px] uppercase tracking-widest transition-all shadow-md shadow-emerald-500/20 flex items-center gap-2"
                    >
                      <Icon icon="mdi:cash-register" class="text-base" />
                      Cobrar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="totalPaginasReparaciones > 1" class="flex justify-between items-center px-6 py-4 bg-gray-50 dark:bg-gray-900/50 border-t border-gray-200 dark:border-gray-700">
          <button
            @click="paginaReparaciones = Math.max(1, paginaReparaciones - 1)"
            :disabled="paginaReparaciones === 1"
            class="px-4 py-2 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 border border-gray-200 dark:border-gray-600"
          >
            <Icon icon="mdi:chevron-left" class="text-base" />
            Anterior
          </button>
          <span class="text-xs font-black text-gray-500 dark:text-gray-400">
            Página {{ paginaReparaciones }} de {{ totalPaginasReparaciones }} · {{ reparacionesEmpresa.length }} registros
          </span>
          <button
            @click="paginaReparaciones = Math.min(totalPaginasReparaciones, paginaReparaciones + 1)"
            :disabled="paginaReparaciones === totalPaginasReparaciones"
            class="px-4 py-2 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 border border-gray-200 dark:border-gray-600"
          >
            Siguiente
            <Icon icon="mdi:chevron-right" class="text-base" />
          </button>
        </div>
      </div>

      <!-- Tabla de Servicios Externos -->
      <div v-if="serviciosExternosEmpresa.length > 0" class="bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div class="px-6 py-4 bg-cyan-50 dark:bg-cyan-900/20 border-b border-cyan-100 dark:border-cyan-800 flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-xl bg-cyan-600 flex items-center justify-center text-white shadow-lg shadow-cyan-500/30">
              <Icon icon="mdi:home-wrench" class="text-xl" />
            </div>
            <div>
              <h3 class="text-base font-black text-cyan-700 dark:text-cyan-300 uppercase tracking-widest">Servicios Externos</h3>
              <p class="text-[10px] font-bold text-cyan-500 dark:text-cyan-400">{{ serviciosExternosEmpresa.length }} registros pendientes</p>
            </div>
          </div>
          <span class="text-lg font-black text-cyan-600 dark:text-cyan-400">
            {{ formatCurrency(serviciosExternosEmpresa.reduce((s, i) => s + (i.saldo || 0), 0)) }}
          </span>
        </div>
        <div class="overflow-x-auto custom-scrollbar">
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Referencia</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Cliente</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Fecha</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Monto Total</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase">Saldo Pendiente</th>
                <th class="px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Acciones</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
              <tr v-for="item in paginadoServiciosExternos" :key="'sed-' + item.id" @click="abrirDetalles(item)" class="hover:bg-cyan-50/30 dark:hover:bg-gray-700/30 transition-all group cursor-pointer">
                <td class="px-6 py-5">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl flex items-center justify-center shadow-sm border bg-cyan-50 text-cyan-600 border-cyan-100 dark:bg-cyan-900/30 dark:border-cyan-800">
                      <Icon icon="mdi:home-wrench" class="text-xl" />
                    </div>
                    <div>
                      <span class="font-black text-gray-900 dark:text-white text-sm">#{{ item.referencia }}</span>
                      <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest">{{ item.tipo }}</p>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-5">
                  <span class="font-bold text-gray-700 dark:text-gray-200 text-sm">{{ item.entidad }}</span>
                </td>
                <td class="px-6 py-5 whitespace-nowrap">
                  <div class="flex flex-col">
                    <span class="font-bold text-gray-700 dark:text-gray-200 text-sm">{{ formatearFecha(item.fecha) }}</span>
                    <span class="text-[10px] font-black text-gray-400 uppercase tracking-widest">{{ diasTranscurridos(item.fecha) }} días</span>
                  </div>
                </td>
                <td class="px-6 py-5">
                  <span class="font-black text-gray-400 text-sm line-through opacity-50">{{ formatCurrency(item.montoTotal) }}</span>
                </td>
                <td class="px-6 py-5">
                  <span class="text-lg font-black text-cyan-500">{{ formatCurrency(item.saldo) }}</span>
                </td>
                <td class="px-6 py-5">
                  <div class="flex justify-center gap-2">
                    <button
                      v-if="obtenerTelefonoDesdeItem(item)"
                      @click.stop="abrirWhatsappDesdeItem(item)"
                      class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-xl hover:bg-green-600 hover:text-white transition-all shadow-sm"
                      title="Enviar mensaje por WhatsApp"
                    >
                      <Icon icon="mdi:whatsapp" class="text-lg" />
                    </button>
                    <button
                      @click.stop="abrirModalPago(item)"
                      class="px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl font-black text-[10px] uppercase tracking-widest transition-all shadow-md shadow-cyan-500/20 flex items-center gap-2"
                    >
                      <Icon icon="mdi:cash-register" class="text-base" />
                      Cobrar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="totalPaginasServiciosExternos > 1" class="flex justify-between items-center px-6 py-4 bg-gray-50 dark:bg-gray-900/50 border-t border-gray-200 dark:border-gray-700">
          <button
            @click="paginaServiciosExternos = Math.max(1, paginaServiciosExternos - 1)"
            :disabled="paginaServiciosExternos === 1"
            class="px-4 py-2 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 border border-gray-200 dark:border-gray-600"
          >
            <Icon icon="mdi:chevron-left" class="text-base" />
            Anterior
          </button>
          <span class="text-xs font-black text-gray-500 dark:text-gray-400">
            Página {{ paginaServiciosExternos }} de {{ totalPaginasServiciosExternos }} · {{ serviciosExternosEmpresa.length }} registros
          </span>
          <button
            @click="paginaServiciosExternos = Math.min(totalPaginasServiciosExternos, paginaServiciosExternos + 1)"
            :disabled="paginaServiciosExternos === totalPaginasServiciosExternos"
            class="px-4 py-2 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 border border-gray-200 dark:border-gray-600"
          >
            Siguiente
            <Icon icon="mdi:chevron-right" class="text-base" />
          </button>
        </div>
      </div>

      <!-- Sin datos -->
      <div v-if="!loading && listadoFiltrado.length === 0" class="bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-gray-200 dark:border-gray-700 p-20 text-center">
        <div class="flex flex-col items-center opacity-30 select-none">
          <Icon icon="mdi:cash-remove" class="text-8xl mb-4" />
          <h4 class="text-2xl font-black text-gray-400 tracking-widest">No hay créditos pendientes</h4>
          <p class="text-sm font-bold text-gray-400 mt-2">Todo está al día en esta categoría.</p>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <Teleport to="body">
      <div v-if="showPagoModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999] animate-fadeIn">
        <div class="bg-white dark:bg-gray-800 rounded-[2rem] shadow-2xl w-full max-w-lg overflow-hidden animate-zoomIn border border-gray-100 dark:border-gray-700">
          <div :class="[
            'px-4 sm:px-8 py-4 sm:py-6 flex items-center gap-3 sm:gap-4 text-white',
            itemSeleccionado.tipo === 'Compra' ? 'bg-gradient-to-r from-rose-600 to-pink-600' : 'bg-gradient-to-r from-emerald-600 to-teal-600'
          ]">
            <div class="p-2 sm:p-3 bg-white/20 rounded-2xl backdrop-blur-md">
              <Icon :icon="itemSeleccionado.tipo === 'Compra' ? 'mdi:bank-transfer-out' : 'mdi:bank-transfer-in'" class="text-2xl sm:text-3xl" />
            </div>
            <div>
              <h3 class="text-base sm:text-xl font-black tracking-tight">Registrar Movimiento</h3>
              <p class="text-white/80 font-bold text-[10px] sm:text-xs uppercase tracking-widest">{{ itemSeleccionado.tipo }} #{{ itemSeleccionado.referencia }}</p>
            </div>
            <button @click="showPagoModal = false" class="ml-auto p-1.5 sm:p-2 bg-white/10 hover:bg-white/20 rounded-xl transition-all">
              <Icon icon="mdi:close" class="text-xl sm:text-2xl" />
            </button>
          </div>

          <div class="p-4 sm:p-8 space-y-4 sm:space-y-6">
            <div class="grid grid-cols-2 gap-3 sm:gap-4">
              <div class="bg-gray-50 dark:bg-gray-900/50 p-3 sm:p-4 rounded-2xl border-2 border-gray-100 dark:border-gray-700">
                <span class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">Saldo Actual</span>
                <span class="text-lg sm:text-2xl font-black text-gray-900 dark:text-white">{{ formatCurrency(itemSeleccionado.saldo) }}</span>
              </div>
              <div class="bg-gray-50 dark:bg-gray-900/50 p-3 sm:p-4 rounded-2xl border-2 border-gray-100 dark:border-gray-700">
                <span class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">Nuevo Saldo</span>
                <span class="text-lg sm:text-2xl font-black text-indigo-500">{{ formatCurrency(nuevoSaldo) }}</span>
              </div>
            </div>

            <div class="space-y-3 sm:space-y-4">
              <div>
                <label class="block text-[10px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1 sm:mb-2 ml-1">Monto a {{ itemSeleccionado.tipo === 'Compra' ? 'Pagar' : 'Cobrar' }} (USD)</label>
                <div class="relative group">
                  <Icon icon="mdi:currency-usd" class="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg sm:text-2xl group-focus-within:text-indigo-500 transition-colors" />
                  <input
                    v-model.number="pagoForm.montoUsd"
                    type="number"
                    step="0.01"
                    :max="itemSeleccionado.saldo"
                    class="w-full pl-9 sm:pl-14 pr-3 sm:pr-4 py-3 sm:py-4 bg-gray-50 dark:bg-gray-900 focus:bg-white dark:focus:bg-gray-700 border-2 border-gray-100 dark:border-gray-700 focus:border-indigo-500 rounded-2xl transition-all outline-none font-black text-lg sm:text-xl text-gray-900 dark:text-white"
                  />
                </div>
              </div>

              <div class="grid grid-cols-2 gap-3 sm:gap-4">
                <div>
                  <label class="block text-[10px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1 sm:mb-2 ml-1">Método</label>
                  <select
                    v-model="pagoForm.metodoPago"
                    class="w-full px-3 sm:px-4 py-3 sm:py-4 bg-gray-50 dark:bg-gray-900 border-2 border-gray-100 dark:border-gray-700 focus:border-indigo-500 rounded-2xl outline-none font-black text-xs sm:text-sm text-gray-900 dark:text-white"
                  >
                    <option v-for="m in metodosPago" :key="m" :value="m">{{ m }}</option>
                  </select>
                </div>
                <div>
                  <label class="block text-[10px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1 sm:mb-2 ml-1">Referencia</label>
                  <input
                    v-model="pagoForm.referencia"
                    type="text"
                    placeholder="Ej: #12345"
                    class="w-full px-3 sm:px-4 py-3 sm:py-4 bg-gray-50 dark:bg-gray-900 border-2 border-gray-100 dark:border-gray-700 focus:border-indigo-500 rounded-2xl outline-none font-black text-xs sm:text-sm text-gray-900 dark:text-white"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="px-4 sm:px-8 pb-4 sm:pb-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              @click="showPagoModal = false"
              class="w-full sm:flex-1 py-3 sm:py-4 border-2 border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400 rounded-2xl font-black text-[10px] sm:text-xs uppercase tracking-widest hover:bg-gray-50 dark:hover:bg-gray-700 transition-all"
            >
              Cancelar
            </button>
            <button
              @click="procesarPago"
              :disabled="loadingPago || pagoForm.montoUsd <= 0 || pagoForm.montoUsd > itemSeleccionado.saldo"
              :class="[
                'w-full sm:flex-1 py-3 sm:py-4 text-white rounded-2xl font-black text-[10px] sm:text-xs uppercase tracking-widest transition-all shadow-xl disabled:opacity-50 flex items-center justify-center gap-2',
                itemSeleccionado.tipo === 'Compra' ? 'bg-rose-600 shadow-rose-500/30' : 'bg-emerald-600 shadow-emerald-500/30'
              ]"
            >
              <Icon :icon="loadingPago ? 'mdi:loading' : 'mdi:check-bold'" :class="{'animate-spin': loadingPago}" />
              {{ loadingPago ? 'Procesando...' : 'Confirmar Pago' }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <ModalConfirm
      :show="confirmModal.show"
      :title="confirmModal.title"
      :message="confirmModal.message"
      :type="confirmModal.type"
      :icon="confirmModal.icon"
      :confirmText="confirmModal.confirmText"
      @confirm="ejecutarAccionConfirmada"
      @cancel="confirmModal.show = false"
    />

    <Teleport to="body">
      <div v-if="modalDetalles.show" class="fixed inset-0 z-50 overflow-hidden flex items-center justify-center p-2 sm:p-4" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="cerrarModalDetalles"></div>
        <div class="relative bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-4xl flex flex-col overflow-hidden transform transition-all animate-fadeIn max-h-[90vh]">

          <div v-if="modalDetalles.loading" class="flex-1 flex flex-col items-center justify-center py-20">
            <Icon icon="mdi:loading" class="animate-spin text-4xl text-indigo-500 mb-4" />
            <p class="text-gray-500 dark:text-gray-400 font-medium">Cargando detalles...</p>
          </div>

          <template v-else-if="detalleSeleccionado?.fullData">
            <div class="px-4 sm:px-6 py-3 sm:py-4 bg-gradient-to-r flex items-center justify-between" :class="detalleSeleccionado.tipo === 'Venta' ? 'from-blue-600 to-indigo-600' : 'from-emerald-600 to-teal-600'">
              <div class="flex items-center gap-2 sm:gap-3">
                <div class="p-1.5 sm:p-2 rounded-xl bg-white/20">
                  <Icon :icon="detalleSeleccionado.tipo === 'Venta' ? 'mdi:receipt-text' : 'mdi:tools'" class="text-white text-lg sm:text-xl" />
                </div>
                <div>
                  <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">
                    {{ detalleSeleccionado.tipo === 'Venta' ? 'Factura' : 'Orden' }} #{{ detalleSeleccionado.fullData?.numeroFactura || detalleSeleccionado.fullData?.numeroOrden || detalleSeleccionado.referencia }}
                  </h3>
                  <p class="text-[8px] sm:text-[10px] text-white/80 uppercase font-medium">
                    {{ detalleSeleccionado.tipo }} • {{ formatearFechaCompleta(detalleSeleccionado.fullData?.fechaVenta || detalleSeleccionado.fullData?.fechaIngreso || detalleSeleccionado.fecha) }}
                  </p>
                </div>
              </div>
              <button @click="cerrarModalDetalles" class="text-white/80 hover:text-white transition-colors">
                <Icon icon="mdi:close" class="text-xl" />
              </button>
            </div>

            <div class="flex bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 p-1 overflow-x-auto custom-scrollbar">
              <button v-for="tab in (detalleSeleccionado.tipo === 'Venta' ? ['resumen', 'productos', 'pagos', 'observaciones'] : ['resumen', 'finanzas', 'fechas', 'observaciones'])"
                      :key="tab" @click="tabActivaDetalle = tab"
                      :class="['flex-1 py-1.5 sm:py-2 text-[8px] sm:text-[10px] font-black uppercase rounded-lg transition-all whitespace-nowrap px-1 sm:px-2', tabActivaDetalle === tab ? (detalleSeleccionado.tipo === 'Venta' ? 'bg-white dark:bg-gray-700 text-blue-600 shadow-sm' : 'bg-white dark:bg-gray-700 text-emerald-600 shadow-sm') : 'text-gray-400 hover:text-gray-600']">
                {{ tab }}
              </button>
            </div>

            <div class="flex-1 overflow-y-auto p-3 sm:p-6">
              <template v-if="detalleSeleccionado.tipo === 'Venta'">
                <div v-if="tabActivaDetalle === 'resumen'" class="space-y-3 sm:space-y-4 animate-fadeIn">
                  <div class="grid grid-cols-2 gap-2 sm:gap-4">
                    <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                      <span class="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-1">Cliente</span>
                      <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ detalleSeleccionado.fullData?.clienteNombre || detalleSeleccionado.entidad }}</span>
                    </div>
                    <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                      <span class="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-1">Vendedor</span>
                      <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ detalleSeleccionado.fullData?.vendedorNombre || 'N/A' }}</span>
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-2">
                    <div class="p-2 sm:p-3 bg-blue-500/5 rounded-xl text-center">
                       <p class="text-[7px] sm:text-[9px] font-bold text-blue-400 uppercase mb-1">Total USD</p>
                       <p class="text-sm sm:text-base font-black text-blue-600">{{ formatCurrency(detalleSeleccionado.fullData?.totalUsd || 0) }}</p>
                    </div>
                    <div class="p-2 sm:p-3 bg-green-500/5 rounded-xl text-center">
                       <p class="text-[7px] sm:text-[9px] font-bold text-green-400 uppercase mb-1">Estado</p>
                       <p class="text-[8px] sm:text-[10px] font-black text-green-600 uppercase">{{ detalleSeleccionado.fullData?.estado || 'CRÉDITO' }}</p>
                    </div>
                  </div>
                </div>

                <div v-if="tabActivaDetalle === 'productos'" class="space-y-1.5 sm:space-y-2 animate-fadeIn">
                  <div v-for="detalle in detalleSeleccionado.fullData?.detalles" :key="detalle.idVentaDetalle" class="flex items-center justify-between p-2 sm:p-3 bg-gray-50 dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700">
                    <div>
                      <p class="text-[10px] sm:text-xs font-bold text-gray-800 dark:text-white uppercase">{{ detalle.nombreProducto || detalle.productoNombre }}</p>
                      <p class="text-[8px] sm:text-[10px] text-gray-400 font-bold uppercase">{{ detalle.cantidad }} Uds x {{ formatCurrency(detalle.precioUnitarioUsd || 0) }}</p>
                    </div>
                    <p class="text-xs sm:text-sm font-black text-blue-600">{{ formatCurrency(detalle.subtotalUsd || 0) }}</p>
                  </div>
                </div>

                <div v-if="tabActivaDetalle === 'pagos'" class="space-y-3 sm:space-y-4 animate-fadeIn">
                   <div v-if="detalleSeleccionado.fullData?.pagos?.length > 0">
                     <div v-for="(pago, i) in detalleSeleccionado.fullData?.pagos" :key="i" class="p-3 sm:p-4 rounded-2xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm mb-2 sm:mb-3">
                       <div class="flex justify-between items-center border-b border-gray-50 dark:border-gray-700 pb-1.5 sm:pb-2 mb-1.5 sm:mb-2">
                         <span class="text-[8px] sm:text-[10px] font-black text-indigo-500 uppercase">Recibo #{{ i+1 }}</span>
                         <span class="text-[8px] sm:text-[10px] font-bold text-gray-400">{{ formatearFechaCompleta(pago.fechaPago) }}</span>
                       </div>
                       <div class="flex justify-between items-end">
                         <div>
                           <p class="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase">Vía: {{ pago.tipoPago || pago.metodoPago }}</p>
                         </div>
                         <p class="text-base sm:text-lg font-black text-green-600">{{ formatCurrency(pago.montoUsd || 0) }}</p>
                       </div>
                     </div>
                   </div>
                   <div v-else class="text-center py-8 sm:py-10">
                     <Icon icon="mdi:cash-off" class="text-3xl sm:text-4xl text-gray-200 mx-auto mb-2" />
                     <p class="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase">No se registran pagos</p>
                   </div>
                </div>

                 <div v-if="tabActivaDetalle === 'observaciones'" class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl min-h-[80px] sm:min-h-[100px] border border-gray-100 dark:border-gray-700 animate-fadeIn">
                   <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-300">{{ detalleSeleccionado.fullData?.observaciones || 'Sin comentarios adicionales.' }}</p>
                 </div>
              </template>

              <template v-else-if="detalleSeleccionado.tipo === 'Reparación' || detalleSeleccionado.tipo === 'Reparacion' || detalleSeleccionado.tipo === 'Servicio Externo'">
                <div v-if="tabActivaDetalle === 'resumen'" class="space-y-3 sm:space-y-4 animate-fadeIn">
                  <div class="grid grid-cols-2 gap-2 sm:gap-4">
                    <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                      <span class="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-1">Cliente</span>
                      <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ detalleSeleccionado.fullData?.clienteNombre || detalleSeleccionado.entidad }}</span>
                    </div>
                    <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                      <span class="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-1">Técnico</span>
                      <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ detalleSeleccionado.fullData?.nombreTecnicoReparador || 'Sin Asignar' }}</span>
                    </div>
                  </div>

                  <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-1">Equipo / Servicio</span>
                    <span class="text-xs sm:text-sm font-medium text-gray-800 dark:text-white">{{ detalleSeleccionado.fullData?.descripcion || '—' }}</span>
                  </div>
                </div>

                <div v-if="tabActivaDetalle === 'finanzas'" class="space-y-3 sm:space-y-4 animate-fadeIn">
                  <div class="bg-gray-50 dark:bg-gray-800 rounded-2xl p-3 sm:p-4 border border-gray-100 dark:border-gray-700">
                    <h4 class="text-[10px] sm:text-xs font-black text-gray-500 uppercase tracking-widest mb-3 sm:mb-4 border-b border-gray-200 dark:border-gray-700 pb-2">Desglose de Costos</h4>

                    <div class="space-y-2 sm:space-y-3">
                      <div class="flex justify-between items-center text-xs sm:text-sm">
                        <span class="text-gray-600 dark:text-gray-400">Diagnóstico</span>
                        <span class="font-bold text-amber-600">
                          {{ (detalleSeleccionado.fullData?.montoPagadoDiagnosticoUsd || 0) > 0 ? formatCurrency(detalleSeleccionado.fullData?.montoPagadoDiagnosticoUsd) : (detalleSeleccionado.fullData?.tipoDiagnostico?.includes('EXPRE') ? '$10.00' : 'Gratis') }}
                        </span>
                      </div>
                      <div class="flex justify-between items-center text-xs sm:text-sm">
                        <span class="text-gray-600 dark:text-gray-400">Servicios / Mano de obra</span>
                        <span class="font-bold text-green-600">{{ formatCurrency(detalleSeleccionado.fullData?.montoServiciosUsd || 0) }}</span>
                      </div>
                      <div class="pt-2 sm:pt-3 mt-2 sm:mt-3 border-t border-gray-200 dark:border-gray-700 flex justify-between items-center">
                        <span class="font-black text-gray-800 dark:text-white text-xs sm:text-sm">TOTAL</span>
                        <span class="text-base sm:text-lg font-black text-indigo-600">{{ formatCurrency(detalleSeleccionado.fullData?.precioTotalUsd || 0) }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="tabActivaDetalle === 'fechas'" class="space-y-3 sm:space-y-4 animate-fadeIn">
                  <div class="relative pl-4 sm:pl-6 border-l-2 border-emerald-200 dark:border-emerald-800 space-y-4 sm:space-y-6">
                    <div class="relative">
                      <div class="absolute -left-[23px] sm:-left-[31px] bg-white dark:bg-gray-900 p-1 rounded-full"><div class="w-2.5 sm:w-3 h-2.5 sm:h-3 bg-emerald-500 rounded-full"></div></div>
                      <div>
                        <h4 class="text-[10px] sm:text-xs font-black text-gray-800 dark:text-white uppercase tracking-wider">Fecha de Ingreso</h4>
                        <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5 sm:mt-1">{{ formatearFechaLarga(detalleSeleccionado.fullData?.fechaIngreso) || '—' }}</p>
                      </div>
                    </div>
                    <div class="relative" v-if="detalleSeleccionado.fullData?.fechaReparacion">
                      <div class="absolute -left-[23px] sm:-left-[31px] bg-white dark:bg-gray-900 p-1 rounded-full"><div class="w-2.5 sm:w-3 h-2.5 sm:h-3 bg-blue-500 rounded-full"></div></div>
                      <div>
                        <h4 class="text-[10px] sm:text-xs font-black text-gray-800 dark:text-white uppercase tracking-wider">Fecha de Reparación</h4>
                        <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5 sm:mt-1">{{ formatearFechaLarga(detalleSeleccionado.fullData?.fechaReparacion) || '—' }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="tabActivaDetalle === 'observaciones'" class="space-y-3 sm:space-y-4 animate-fadeIn">
                  <div v-if="detalleSeleccionado.fullData?.problema || detalleSeleccionado.fullData?.Problema" class="p-3 sm:p-4 bg-red-50 dark:bg-red-900/10 rounded-2xl border border-red-100 dark:border-red-900/30">
                     <h4 class="text-[10px] sm:text-xs font-black text-red-800 dark:text-red-400 uppercase tracking-widest mb-1.5 sm:mb-2 flex items-center gap-1.5 sm:gap-2">
                       <Icon icon="mdi:alert-circle" class="text-base sm:text-lg" /> Problema Reportado
                     </h4>
                     <p class="text-[10px] sm:text-xs font-medium text-red-900 dark:text-red-300 whitespace-pre-wrap">{{ detalleSeleccionado.fullData?.problema || detalleSeleccionado.fullData?.Problema }}</p>
                  </div>

                  <div class="p-3 sm:p-4 bg-blue-50 dark:bg-blue-900/10 rounded-2xl border border-blue-100 dark:border-blue-900/30">
                     <h4 class="text-[10px] sm:text-xs font-black text-blue-800 dark:text-blue-400 uppercase tracking-widest mb-1.5 sm:mb-2 flex items-center gap-1.5 sm:gap-2">
                       <Icon icon="mdi:clipboard-text-outline" class="text-base sm:text-lg" /> Actividades Realizadas
                     </h4>
                     <p class="text-[10px] sm:text-xs font-medium text-blue-900 dark:text-blue-300 whitespace-pre-wrap">{{ detalleSeleccionado.fullData?.actividadesRealizadas || 'Sin detalles' }}</p>
                  </div>

                  <div v-if="detalleSeleccionado.fullData?.repuestos || detalleSeleccionado.fullData?.Repuestos" class="p-3 sm:p-4 bg-emerald-50 dark:bg-emerald-900/10 rounded-2xl border border-emerald-100 dark:border-emerald-900/30">
                     <h4 class="text-[10px] sm:text-xs font-black text-emerald-800 dark:text-emerald-400 uppercase tracking-widest mb-1.5 sm:mb-2 flex items-center gap-1.5 sm:gap-2">
                       <Icon icon="mdi:cog-box" class="text-base sm:text-lg" /> Repuestos Utilizados
                     </h4>
                     <p class="text-[10px] sm:text-xs font-medium text-emerald-900 dark:text-emerald-300 whitespace-pre-wrap">{{ detalleSeleccionado.fullData?.repuestos || detalleSeleccionado.fullData?.Repuestos }}</p>
                  </div>
                </div>
              </template>

              <template v-else>
                 <div class="p-8 sm:p-10 text-center">
                    <Icon icon="mdi:information-outline" class="text-3xl sm:text-4xl text-gray-300 mx-auto mb-2" />
                    <p class="text-xs sm:text-sm font-bold text-gray-500 uppercase">Detalle en construcción.</p>
                 </div>
              </template>
            </div>
          </template>

          <template v-else>
            <div class="p-12 sm:p-20 text-center">
              <p class="text-gray-500 dark:text-gray-400 font-medium">No se pudieron cargar los detalles.</p>
            </div>
          </template>

        </div>
      </div>
    </Teleport>

    <input ref="importFile" type="file" accept=".xlsx,.xls" @change="handleImportFile" style="display:none" />
  </div>
</template>

<script>
import { Icon } from '@iconify/vue';
import { useToast } from "vue-toastification";
import { obtenerResumenCreditos, registrarPagoCompra, registrarPagoReparacion } from '@/api/creditoEmpresa.js';
import { registrarPagoVenta, obtenerVentaConRelaciones } from '@/api/ventas.js';
import { obtenerRecepcionConRelaciones } from '@/api/recepcionEquipo.js';
import { obtenerVendedores } from '@/api/vendedores.js';
import { imprimirReporteCreditos, imprimirReportePorCliente } from '@/utils/reporteCreditosGenerator.js';
import ModalConfirm from '@/components/ModalConfirm.vue';
import * as XLSX from 'xlsx';
import { obtenerClientePorId } from '@/api/clientes.js';
import {
  obtenerPagoSemanal,
  obtenerProximoMiercoles,
  formatearFechaMiercoles,
  CODIGO_CASHEA
} from '@/api/creditoApp.js';

export default {
  name: 'GestionCreditos',
  components: {
    Icon,
    ModalConfirm
  },
  setup() {
    const toast = useToast();
    return { toast, imprimirReporteCreditos, imprimirReportePorCliente };
  },
  data() {
    return {
      activeTab: 'empresa',
      confirmModal: {
        show: false,
        title: '',
        message: '',
        type: 'primary',
        icon: '',
        confirmText: '',
        callback: null
      },
      tabs: [
        { id: 'empresa', name: 'Créditos Empresa', shortName: 'Empresa', icon: 'mdi:domain' },
        { id: 'cashea', name: 'Cashea', shortName: 'Cashea', icon: 'mdi:cellphone-check' },
        { id: 'clientes', name: 'Reporte por Cliente', shortName: 'Clientes', icon: 'mdi:account-group' },
        { id: 'reportes', name: 'Reportes Globales', shortName: 'Reportes', icon: 'mdi:chart-box-outline' }
      ],
      datos: {
        compras: [],
        ventas: [],
        reparaciones: [],
        serviciosExternos: []
      },
      loading: false,
      filtroBusqueda: '',
      clientesExpandidos: [],
      showExportMenu: false,
      clienteSeleccionadoWhatsapp: null,
      telefonoCache: {},

      showPagoModal: false,
      loadingPago: false,
      itemSeleccionado: {},
      pagoForm: {
        montoUsd: 0,
        metodoPago: 'Efectivo',
        referencia: '',
        observaciones: ''
      },
      metodosPago: ['Efectivo', 'Transferencia', 'Pago Móvil', 'Zelle', 'Punto de Venta'],

      modalDetalles: { show: false, loading: false },
      detalleSeleccionado: null,
      tabActivaDetalle: 'resumen',
      vendedoresMap: new Map(),

      registrosPorPagina: 5,
      paginaVentas: 1,
      paginaReparaciones: 1,
      paginaServiciosExternos: 1,

      // 👈 Pago semanal Cashea (backend)
      pagoSemanalCashea: null,
      loadingPagoSemanal: false,
      fechaMiercolesSeleccionada: null,
      codigoCashea: CODIGO_CASHEA
    };
  },
  computed: {
    isSuperAdmin() {
      const rol = (localStorage.getItem('rol') || '').toLowerCase();
      return rol.includes('superadmin') || rol.includes('super admin') || rol.includes('administrador') || rol === 'admin';
    },

    ventasEmpresa() {
      const ventas = this.datos.ventas || [];
      let list = ventas.filter(i => !i.subTipo?.toLowerCase().includes('cashea'));
      if (this.filtroBusqueda) {
        const q = this.filtroBusqueda.toLowerCase();
        list = list.filter(i =>
          i.referencia?.toLowerCase().includes(q) ||
          i.entidad?.toLowerCase().includes(q) ||
          i.subTipo?.toLowerCase().includes(q)
        );
      }
      return list.sort((a, b) => (a.entidad || '').localeCompare(b.entidad || ''));
    },

    reparacionesEmpresa() {
      const reparaciones = this.datos.reparaciones || [];
      let list = reparaciones.filter(i => !i.subTipo?.toLowerCase().includes('cashea'));
      if (this.filtroBusqueda) {
        const q = this.filtroBusqueda.toLowerCase();
        list = list.filter(i =>
          i.referencia?.toLowerCase().includes(q) ||
          i.entidad?.toLowerCase().includes(q) ||
          i.subTipo?.toLowerCase().includes(q)
        );
      }
      return list.sort((a, b) => (a.entidad || '').localeCompare(b.entidad || ''));
    },

    serviciosExternosEmpresa() {
      const serviciosExternos = this.datos.serviciosExternos || [];
      let list = serviciosExternos.filter(i => !i.subTipo?.toLowerCase().includes('cashea'));
      if (this.filtroBusqueda) {
        const q = this.filtroBusqueda.toLowerCase();
        list = list.filter(i =>
          i.referencia?.toLowerCase().includes(q) ||
          i.entidad?.toLowerCase().includes(q) ||
          i.subTipo?.toLowerCase().includes(q)
        );
      }
      return list.sort((a, b) => (a.entidad || '').localeCompare(b.entidad || ''));
    },

    listadoFiltrado() {
      return [...this.ventasEmpresa, ...this.reparacionesEmpresa, ...this.serviciosExternosEmpresa];
    },

    paginadoVentas() {
      const inicio = (this.paginaVentas - 1) * this.registrosPorPagina;
      return this.ventasEmpresa.slice(inicio, inicio + this.registrosPorPagina);
    },
    paginadoReparaciones() {
      const inicio = (this.paginaReparaciones - 1) * this.registrosPorPagina;
      return this.reparacionesEmpresa.slice(inicio, inicio + this.registrosPorPagina);
    },
    paginadoServiciosExternos() {
      const inicio = (this.paginaServiciosExternos - 1) * this.registrosPorPagina;
      return this.serviciosExternosEmpresa.slice(inicio, inicio + this.registrosPorPagina);
    },

    totalPaginasVentas() {
      return Math.max(1, Math.ceil(this.ventasEmpresa.length / this.registrosPorPagina));
    },
    totalPaginasReparaciones() {
      return Math.max(1, Math.ceil(this.reparacionesEmpresa.length / this.registrosPorPagina));
    },
    totalPaginasServiciosExternos() {
      return Math.max(1, Math.ceil(this.serviciosExternosEmpresa.length / this.registrosPorPagina));
    },

    listadoActual() {
      if (this.activeTab === 'empresa') {
        const ventas = this.datos.ventas || [];
        const reparaciones = this.datos.reparaciones || [];
        const serviciosExternos = this.datos.serviciosExternos || [];
        return [...ventas, ...reparaciones, ...serviciosExternos].filter(i => !i.subTipo?.toLowerCase().includes('cashea'));
      }

      if (this.activeTab === 'cashea') {
        if (!this.pagoSemanalCashea?.detalle) return [];
        return this.pagoSemanalCashea.detalle.map(d => ({
          id: `${d.origen}-${d.idCreditoPadre}`,
          idCreditoPadre: d.idCreditoPadre,
          referencia: d.numeroFactura,
          entidad: d.cliente,
          tipo: d.origen,
          fecha: d.fechaGeneracion,
          montoTotal: d.montoTotalCuotas,
          saldo: d.montoTotalCuotas,
          subTipo: 'cashea',
          isCuota: false,
          cuotas: d.cuotas,
          cantidadCuotas: d.cantidadCuotas
        }));
      }

      return this.datos[this.activeTab] || [];
    },

    totalEmpresaPendiente() {
      const ventas = this.datos.ventas || [];
      const reparaciones = this.datos.reparaciones || [];
      const serviciosExternos = this.datos.serviciosExternos || [];
      const all = [...ventas, ...reparaciones, ...serviciosExternos];
      return all.filter(i => !i.subTipo?.toLowerCase().includes('cashea')).reduce((acc, i) => acc + i.saldo, 0);
    },

    // 👈 NUEVO: Neto que Cashea pagará este miércoles (pestaña Cashea + card header)
    totalCasheaPendiente() {
      if (this.pagoSemanalCashea?.montoNetoRecibir) {
        return this.pagoSemanalCashea.montoNetoRecibir;
      }
      // Fallback mientras carga: suma local
      const ventas = this.datos.ventas || [];
      const reparaciones = this.datos.reparaciones || [];
      const all = [...ventas, ...reparaciones];
      return all
        .filter(i => i.subTipo?.toLowerCase().includes('cashea'))
        .reduce((acc, i) => acc + (i.saldo || 0), 0);
    },

    // 👈 NUEVO: Deuda total histórica de Cashea (informativo, tooltip)
    totalCasheaDeudaTotal() {
      const ventas = this.datos.ventas || [];
      const reparaciones = this.datos.reparaciones || [];
      const all = [...ventas, ...reparaciones];
      return all
        .filter(i => i.subTipo?.toLowerCase().includes('cashea'))
        .reduce((acc, i) => acc + (i.saldo || 0), 0);
    },

    // 👈 NUEVO: Cuotas totales de la semana
    totalCuotasSemanal() {
      if (!this.pagoSemanalCashea?.detalle) return 0;
      return this.pagoSemanalCashea.detalle.reduce((sum, d) => sum + (d.cantidadCuotas || 0), 0);
    },

    totalGeneralPendiente() {
      return this.totalEmpresaPendiente + this.totalCasheaDeudaTotal;
    },
    nuevoSaldo() {
      const saldo = this.itemSeleccionado.saldo || 0;
      const monto = this.pagoForm.montoUsd || 0;
      return Math.max(0, saldo - monto);
    },
    resumenPorCliente() {
      const ventas = this.datos.ventas || [];
      const reparaciones = this.datos.reparaciones || [];
      const serviciosExternos = this.datos.serviciosExternos || [];
      const all = [...ventas, ...reparaciones, ...serviciosExternos].filter(i => !i.subTipo?.toLowerCase().includes('cashea'));
      const agrupado = {};
      const filtro = this.filtroBusqueda.toLowerCase();

      all.forEach(item => {
        const nombre = item.entidad || 'Desconocido';
        if (!agrupado[nombre]) {
          agrupado[nombre] = {
            entidad: nombre,
            deudaVentas: 0,
            deudaReparaciones: 0,
            deudaServiciosExternos: 0,
            totalDeuda: 0,
            detalles: []
          };
        }

        if (item.tipo === 'Venta') {
          agrupado[nombre].deudaVentas += item.saldo;
        } else if (item.tipo === 'Reparación' || item.tipo === 'Reparacion') {
          agrupado[nombre].deudaReparaciones += item.saldo;
        } else if (item.tipo === 'Servicio Externo') {
          agrupado[nombre].deudaServiciosExternos += item.saldo;
        }

        agrupado[nombre].totalDeuda += item.saldo;
        agrupado[nombre].detalles.push(item);
      });

      return Object.values(agrupado)
        .filter(c => c.totalDeuda > 0 && (!filtro || c.entidad.toLowerCase().includes(filtro)))
        .sort((a, b) => b.totalDeuda - a.totalDeuda);
    },
    statsReporte() {
      const ventas = this.datos.ventas || [];
      const reparaciones = this.datos.reparaciones || [];
      const serviciosExternos = this.datos.serviciosExternos || [];
      const all = [...ventas, ...reparaciones, ...serviciosExternos].filter(i => !i.subTipo?.toLowerCase().includes('cashea'));

      const res = {
        totalPendiente: all.reduce((acc, i) => acc + i.saldo, 0),
        totalOriginal: all.reduce((acc, i) => acc + i.montoTotal, 0),
        countEmpresa: all.length,
        montoEmpresa: all.reduce((acc, i) => acc + i.saldo, 0),
        proximosVencimientos: [...all].sort((a, b) => new Date(a.fecha) - new Date(b.fecha)).slice(0, 5)
      };

      res.totalPagado = res.totalOriginal - res.totalPendiente;
      res.porcentajeCobrado = res.totalOriginal > 0 ? (res.totalPagado / res.totalOriginal) * 100 : 0;

      return res;
    }
  },
  watch: {
    activeTab(newTab) {
      this.paginaVentas = 1;
      this.paginaReparaciones = 1;
      this.paginaServiciosExternos = 1;

      if (newTab === 'cashea') {
        this.cargarPagoSemanalCashea();
      }
    },
    filtroBusqueda() {
      this.paginaVentas = 1;
      this.paginaReparaciones = 1;
      this.paginaServiciosExternos = 1;
    }
  },
  created() {
    this.window = window;
  },
  async mounted() {
    await this.cargarVendedores();
    await this.cargarDatos();

    const tab = this.$route.query.tab;
    if (tab && this.tabs.some(t => t.id === tab)) {
      this.activeTab = tab;
    }

    if (this.activeTab === 'cashea') {
      await this.cargarPagoSemanalCashea();
    }
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || isNaN(value)) return '$0.00';
      const num = typeof value === 'string' ? parseFloat(value) : value;
      return new Intl.NumberFormat('es-VE', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num);
    },

    // ==================== CASHEA: PAGO SEMANAL ====================
    async cargarPagoSemanalCashea(fecha = null) {
      this.loadingPagoSemanal = true;
      try {
        const miercoles = fecha || this.fechaMiercolesSeleccionada || obtenerProximoMiercoles();
        this.fechaMiercolesSeleccionada = miercoles;

        const res = await obtenerPagoSemanal(this.codigoCashea, miercoles);

        if (res.success) {
          this.pagoSemanalCashea = res.data;
        } else {
          this.pagoSemanalCashea = null;
          this.toast.error(res.error || 'Error al cargar pago semanal');
        }
      } catch (e) {
        console.error('Error cargando pago semanal:', e);
        this.pagoSemanalCashea = null;
        this.toast.error('Error de conexión al cargar Cashea');
      } finally {
        this.loadingPagoSemanal = false;
      }
    },

    cambiarMiercoles(dias) {
      if (!this.fechaMiercolesSeleccionada) {
        this.fechaMiercolesSeleccionada = obtenerProximoMiercoles();
      }
      const nueva = new Date(this.fechaMiercolesSeleccionada);
      nueva.setDate(nueva.getDate() + (dias * 7));
      this.cargarPagoSemanalCashea(nueva);
    },

    formatearMiercoles(fecha) {
      return formatearFechaMiercoles(fecha);
    },

    // ==================== WHATSAPP ====================
    async obtenerTelefonoCliente(idCliente) {
      if (!idCliente) return null;

      if (this.telefonoCache[idCliente]) {
        return this.telefonoCache[idCliente];
      }

      try {
        const res = await obtenerClientePorId(idCliente);

        if (res.success && res.data) {
          const telefono = res.data.telefono ||
                         res.data.Telefono ||
                         res.data.telefonoCliente ||
                         res.data.TelefonoCliente ||
                         res.data.telefono_contacto ||
                         null;

          if (telefono) {
            this.telefonoCache[idCliente] = telefono;
            return telefono;
          }
        }
      } catch (error) {
        console.error('Error obteniendo teléfono del cliente:', error);
      }
      return null;
    },

    obtenerTelefonoDesdeItem(item) {
      if (!item) return null;

      if (item.telefonoCliente) return item.telefonoCliente;
      if (item.telefono) return item.telefono;
      if (item.Telefono) return item.Telefono;

      if (item.cliente && item.cliente.telefono) {
        return item.cliente.telefono;
      }

      if (item.fullData) {
        if (item.fullData.cliente && item.fullData.cliente.telefono) {
          return item.fullData.cliente.telefono;
        }
        if (item.fullData.telefonoCliente) {
          return item.fullData.telefonoCliente;
        }
        if (item.fullData.clienteTelefono) {
          return item.fullData.clienteTelefono;
        }
      }

      const idCliente = item.idCliente || item.clienteId || item.id_cliente;
      if (idCliente && this.telefonoCache[idCliente]) {
        return this.telefonoCache[idCliente];
      }

      return null;
    },

    async enriquecerConTelefono(item) {
      if (!item) return null;

      if (item.telefonoCliente || item.telefono) {
        return item.telefonoCliente || item.telefono;
      }

      const idCliente = item.idCliente || item.clienteId || item.id_cliente;
      if (!idCliente) return null;

      const telefono = await this.obtenerTelefonoCliente(idCliente);
      if (telefono) {
        item.telefonoCliente = telefono;
        return telefono;
      }

      return null;
    },

    async abrirWhatsappDesdeItem(item) {
      if (!item) {
        this.toast.warning('No se pudo obtener la información del crédito');
        return;
      }

      let telefono = this.obtenerTelefonoDesdeItem(item);

      if (!telefono) {
        telefono = await this.enriquecerConTelefono(item);
      }

      const nombreCliente = item.entidad || 'Cliente';
      const saldo = item.saldo || 0;
      const referencia = item.referencia || '';
      const tipo = item.tipo || 'Crédito';
      const subTipo = item.subTipo || '';
      const fecha = item.fecha ? this.formatearFechaCompleta(item.fecha) : 'N/A';
      const montoTotal = item.montoTotal || 0;

      if (!telefono) {
        this.toast.warning(`El cliente ${nombreCliente} no tiene número de teléfono registrado`);
        return;
      }

      let cleanPhone = telefono.toString().replace(/\D/g, '');
      if (cleanPhone.length === 10 && !cleanPhone.startsWith('58')) {
        cleanPhone = '58' + cleanPhone;
      } else if (cleanPhone.length === 11 && cleanPhone.startsWith('0')) {
        cleanPhone = '58' + cleanPhone.substring(1);
      }

      let tipoTexto = '';

      if (tipo === 'Venta') {
        tipoTexto = 'FACTURA DE VENTA';
      } else if (tipo === 'Reparación' || tipo === 'Reparacion') {
        tipoTexto = 'ORDEN DE REPARACION';
      } else if (tipo === 'Compra') {
        tipoTexto = 'COMPRA A PROVEEDOR';
      } else {
        tipoTexto = 'CREDITO';
      }

      const subTipoTexto = subTipo ? ` (${subTipo})` : '';

      let mensaje = `Hola ${nombreCliente}, espero que se encuentre bien.\n\n`;
      mensaje += `Le escribimos de Jean Informatico C.A. para recordarle que tiene un saldo pendiente en nuestra empresa.\n\n`;
      mensaje += `DETALLE DEL CREDITO\n`;
      mensaje += `----------------------------------------\n`;
      mensaje += `Tipo: ${tipoTexto}${subTipoTexto}\n`;
      mensaje += `Referencia: #${referencia}\n`;
      mensaje += `Fecha: ${fecha}\n`;
      mensaje += `Monto Total: ${this.formatCurrency(montoTotal)}\n`;
      mensaje += `Saldo Pendiente: ${this.formatCurrency(saldo)}\n`;

      if (tipo === 'Reparación' || tipo === 'Reparacion') {
        const equipo = item.descripcion || item.equipo || item.fullData?.descripcion || '';
        const problema = item.problema || item.fullData?.problema || '';
        if (equipo) mensaje += `Equipo: ${equipo}\n`;
        if (problema) mensaje += `Problema: ${problema}\n`;
      }

      if (tipo === 'Venta') {
        const detalles = item.fullData?.detalles || item.detalles || [];
        if (detalles.length > 0) {
          mensaje += `\nProductos/Servicios:\n`;
          detalles.forEach(d => {
            const nombre = d.nombreProducto || d.productoNombre || d.nombre || 'Producto';
            const cant = d.cantidad || 1;
            const precio = d.precioUnitarioUsd || d.precio || 0;
            mensaje += `  - ${nombre} (${cant} x ${this.formatCurrency(precio)})\n`;
          });
        }
      }

      mensaje += `\nLe agradecemos de antemano por su atencion y quedamos atentos para cualquier consulta.\n\n`;
      mensaje += `Para mas informacion o coordinar el pago, puede contactarnos:\n`;
      mensaje += `Telefono: 0416-7594723\n`;
      mensaje += `Email: jean.informatico@gmail.com\n`;
      mensaje += `Direccion: C.C. Latin Center PB Local 01, Acarigua - Portuguesa\n\n`;
      mensaje += `Saludos cordiales,\n`;
      mensaje += `Jean Informatico C.A.`;

      const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(mensaje)}`;
      window.open(url, '_blank');

      this.toast.success(`Abriendo WhatsApp con ${nombreCliente}`);
    },

    async abrirWhatsappCliente(cliente) {
      if (!cliente || !cliente.entidad) {
        this.toast.warning('Selecciona un cliente primero');
        return;
      }

      let telefono = '';
      let nombreCliente = cliente.entidad || 'Cliente';
      let totalDeuda = cliente.totalDeuda || 0;
      let detallesMensaje = [];

      if (cliente.detalles && cliente.detalles.length > 0) {
        for (const det of cliente.detalles) {
          if (!det.telefonoCliente && !det.telefono) {
            await this.enriquecerConTelefono(det);
          }

          if (det.telefonoCliente && !telefono) telefono = det.telefonoCliente;
          if (det.telefono && !telefono) telefono = det.telefono;

          const tipo = det.tipo || 'Credito';
          const ref = det.referencia || 'N/A';
          const saldo = det.saldo || 0;
          const fecha = det.fecha ? this.formatearFechaCompleta(det.fecha) : 'N/A';
          const subTipo = det.subTipo ? ` (${det.subTipo})` : '';

          detallesMensaje.push(`- ${tipo}${subTipo} #${ref} - ${this.formatCurrency(saldo)} (${fecha})`);
        }
      }

      if (!telefono) {
        this.toast.warning(`El cliente ${nombreCliente} no tiene numero de telefono registrado`);
        return;
      }

      let cleanPhone = telefono.toString().replace(/\D/g, '');
      if (cleanPhone.length === 10 && !cleanPhone.startsWith('58')) {
        cleanPhone = '58' + cleanPhone;
      } else if (cleanPhone.length === 11 && cleanPhone.startsWith('0')) {
        cleanPhone = '58' + cleanPhone.substring(1);
      }

      let mensaje = `Hola ${nombreCliente}, espero que se encuentre bien.\n\n`;
      mensaje += `Le escribimos de Jean Informatico C.A. para compartirle el estado de cuenta de sus creditos con nosotros.\n\n`;
      mensaje += `RESUMEN DE DEUDA\n`;
      mensaje += `----------------------------------------\n`;
      mensaje += `Saldo total pendiente: ${this.formatCurrency(totalDeuda)}\n\n`;

      if (detallesMensaje.length > 0) {
        mensaje += `DETALLE DE CREDITOS:\n`;
        mensaje += detallesMensaje.join('\n');
        mensaje += `\n\n`;
      }

      mensaje += `Agradecemos su confianza y quedamos atentos para cualquier consulta.\n\n`;
      mensaje += `Para mas informacion o coordinar el pago, puede contactarnos:\n`;
      mensaje += `Telefono: 0416-7594723\n`;
      mensaje += `Email: jean.informatico@gmail.com\n`;
      mensaje += `Direccion: C.C. Latin Center PB Local 01, Acarigua - Portuguesa\n\n`;
      mensaje += `Saludos cordiales,\n`;
      mensaje += `Jean Informatico C.A.`;

      const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(mensaje)}`;
      window.open(url, '_blank');

      this.toast.success(`Abriendo WhatsApp con ${nombreCliente}`);
    },

    // ==================== EXPORTACIONES ====================
    exportToExcel() {
      try {
        const ventas = this.datos.ventas || [];
        const reparaciones = this.datos.reparaciones || [];
        const serviciosExternos = this.datos.serviciosExternos || [];
        const all = [...ventas, ...reparaciones, ...serviciosExternos].filter(i => !i.subTipo?.toLowerCase().includes('cashea'));
        if (all.length === 0) {
          this.toast.warning('No hay datos para exportar');
          return;
        }

        const datos = all.map(item => ({
          'Referencia': item.referencia || '',
          'Tipo': item.tipo || '',
          'Cliente/Proveedor': item.entidad || '',
          'Fecha': item.fecha ? new Date(item.fecha).toLocaleString('es-ES') : '',
          'Monto Total': item.montoTotal || 0,
          'Saldo Pendiente': item.saldo || 0,
          'SubTipo': item.subTipo || '',
          'Estado': item.estado || 'Pendiente'
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(datos);
        ws['!cols'] = [
          { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 20 },
          { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }
        ];
        XLSX.utils.book_append_sheet(wb, ws, 'Créditos');

        const fecha = new Date();
        const nombreArchivo = `Creditos_${fecha.getFullYear()}-${String(fecha.getMonth()+1).padStart(2,'0')}-${String(fecha.getDate()).padStart(2,'0')}.xlsx`;
        XLSX.writeFile(wb, nombreArchivo);
        this.toast.success(`Exportados ${all.length} créditos a Excel`);
        this.showExportMenu = false;
      } catch (error) {
        console.error('Error exportando Excel:', error);
        this.toast.error('Error al exportar: ' + error.message);
      }
    },

    exportCasheaToExcel() {
      try {
        if (!this.pagoSemanalCashea?.detalle || this.pagoSemanalCashea.detalle.length === 0) {
          this.toast.warning('No hay datos Cashea para exportar');
          return;
        }

        const filas = [];
        this.pagoSemanalCashea.detalle.forEach(credito => {
          credito.cuotas.forEach(cuota => {
            filas.push({
              'Referencia': credito.numeroFactura,
              'Origen': credito.origen,
              'Cliente': credito.cliente,
              'Fecha Generación': credito.fechaGeneracion
                ? new Date(credito.fechaGeneracion).toLocaleDateString('es-ES')
                : '',
              'N° Cuota': cuota.numeroCuota,
              'Fecha Vencimiento': cuota.fechaVencimiento
                ? new Date(cuota.fechaVencimiento).toLocaleDateString('es-ES')
                : '',
              'Monto USD': cuota.montoUsd,
              'Estado': cuota.estado
            });
          });
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(filas);
        ws['!cols'] = [
          { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 18 },
          { wch: 10 }, { wch: 18 }, { wch: 12 }, { wch: 12 }
        ];
        XLSX.utils.book_append_sheet(wb, ws, 'Cashea Semanal');

        const fecha = new Date();
        const nombreArchivo = `Cashea_${fecha.getFullYear()}-${String(fecha.getMonth()+1).padStart(2,'0')}-${String(fecha.getDate()).padStart(2,'0')}.xlsx`;
        XLSX.writeFile(wb, nombreArchivo);
        this.toast.success(`Exportados ${filas.length} registros Cashea`);
        this.showExportMenu = false;
      } catch (error) {
        console.error('Error exportando Cashea:', error);
        this.toast.error('Error al exportar: ' + error.message);
      }
    },

    exportReportesToExcel() {
      this.exportToExcel();
    },

    exportReporteCliente() {
      try {
        const data = this.resumenPorCliente;
        if (data.length === 0) {
          this.toast.warning('No hay clientes con deuda');
          return;
        }

        const datos = data.map(item => ({
          'Cliente': item.entidad || '',
          'Deuda en Ventas': item.deudaVentas || 0,
          'Deuda en Reparaciones': item.deudaReparaciones || 0,
          'Total Pendiente': item.totalDeuda || 0,
          'Cantidad de Créditos': item.detalles?.length || 0
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(datos);
        ws['!cols'] = [
          { wch: 30 }, { wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 15 }
        ];
        XLSX.utils.book_append_sheet(wb, ws, 'Reporte Clientes');

        const fecha = new Date();
        const nombreArchivo = `Reporte_Clientes_${fecha.getFullYear()}-${String(fecha.getMonth()+1).padStart(2,'0')}-${String(fecha.getDate()).padStart(2,'0')}.xlsx`;
        XLSX.writeFile(wb, nombreArchivo);
        this.toast.success(`Exportado reporte de ${data.length} clientes`);
        this.showExportMenu = false;
      } catch (error) {
        console.error('Error exportando reporte cliente:', error);
        this.toast.error('Error al exportar: ' + error.message);
      }
    },

    exportToPDF() {
      this.imprimirReporteCreditos(this.datos, this.statsReporte);
      this.showExportMenu = false;
    },

    triggerImport() {
      const input = this.$refs.importFile;
      if (input) input.click();
    },

    async handleImportFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      this.loading = true;
      try {
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });

        if (rows.length === 0) {
          this.toast.warning('El archivo está vacío');
          this.loading = false;
          return;
        }

        this.confirmModal = {
          show: true,
          title: 'Importar Créditos',
          message: `Se van a importar <b>${rows.length}</b> registros. ¿Deseas continuar?`,
          type: 'warning',
          icon: 'mdi:import',
          confirmText: 'Sí, Importar',
          callback: async () => {
            await this.procesarImportacion(rows);
          }
        };

      } catch (error) {
        console.error('Error importando:', error);
        this.toast.error('Error al importar: ' + error.message);
        this.loading = false;
      } finally {
        event.target.value = '';
      }
    },

    async procesarImportacion(rows) {
      try {
        this.toast.success(`Se procesaron ${rows.length} registros. La importación está en desarrollo.`);
        await this.cargarDatos();
      } catch (error) {
        console.error('Error procesando importación:', error);
        this.toast.error('Error al importar: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    async cargarVendedores() {
      try {
        const response = await obtenerVendedores();
        if (response.success) {
          (response.data || []).forEach(v => {
            this.vendedoresMap.set(v.idVendedor, `${v.nombre} ${v.apellido || ''}`.trim());
          });
        }
      } catch (error) {
        console.error('Error cargando vendedores:', error);
      }
    },

    toggleCliente(entidad) {
      const index = this.clientesExpandidos.indexOf(entidad);
      if (index > -1) {
        this.clientesExpandidos.splice(index, 1);
      } else {
        this.clientesExpandidos.push(entidad);
      }
    },

    isClienteExpanded(entidad) {
      return this.clientesExpandidos.includes(entidad);
    },

    // ==================== LIQUIDACIÓN MASIVA CASHEA ====================
    async abrirLiquidacionMasiva() {
      const total = this.pagoSemanalCashea?.montoNetoRecibir || this.totalCasheaPendiente;
      const cantCreditos = this.pagoSemanalCashea?.cantidadCreditos || 0;

      this.confirmModal = {
        show: true,
        title: 'Liquidación Cashea',
        message: `¿Deseas procesar la liquidación semanal de Cashea?<br><br>
          <b>Miércoles:</b> ${this.pagoSemanalCashea?.fechaPagoFormateada || 'N/A'}<br>
          <b>Créditos:</b> ${cantCreditos}<br>
          <b>Bruto:</b> ${this.formatCurrency(this.pagoSemanalCashea?.totalBruto || 0)}<br>
          <b>Comisión:</b> -${this.formatCurrency(this.pagoSemanalCashea?.descuentoComision || 0)}<br>
          <b class="text-teal-600">Neto a recibir: ${this.formatCurrency(total)}</b><br><br>
          Esto marcará todas las cuotas como <b>PAGADAS</b> y las sacará del sistema.`,
        type: 'primary',
        icon: 'mdi:bank-transfer',
        confirmText: 'Procesar Ahora',
        callback: this.confirmarLiquidacionMasiva
      };
    },

    async ejecutarAccionConfirmada() {
      this.confirmModal.show = false;
      if (this.confirmModal.callback) {
        await this.confirmModal.callback();
      }
    },

    async confirmarLiquidacionMasiva() {
      this.loading = true;
      try {
        const idUsuario = localStorage.getItem('idUsuario') || 1;
        const fechaActual = new Date().toISOString();

        if (this.pagoSemanalCashea?.detalle) {
          for (const credito of this.pagoSemanalCashea.detalle) {
            for (const cuota of credito.cuotas) {
              if (credito.origen === 'Venta') {
                await registrarPagoVenta({
                  idVenta: credito.idCreditoPadre,
                  idCuota: cuota.idCuota,
                  montoUsd: cuota.montoUsd,
                  metodoPago: 'Transferencia',
                  referencia: 'Liquidación Cashea',
                  idUsuario: idUsuario,
                  fechaPago: fechaActual
                });
              } else {
                await registrarPagoReparacion({
                  idSalidaEquipoDetalle: credito.idCreditoPadre,
                  idCuota: cuota.idCuota,
                  numeroRecibo: `LQ-${Date.now()}-${cuota.idCuota}`,
                  montoUsd: cuota.montoUsd,
                  montoBs: 0,
                  tasaBsUsd: 1,
                  idFuenteTasa: 1,
                  idTasaVenta: 1,
                  metodoPago: 'Transferencia',
                  referencia: 'Liquidación Cashea',
                  idUsuario: idUsuario,
                  estado: "Completado",
                  tipoPago: "Abono",
                  fechaPago: fechaActual
                });
              }
            }
          }
        }

        this.toast.success('Liquidación de Cashea completada exitosamente');
        await this.cargarDatos();
        await this.cargarPagoSemanalCashea();
      } catch (e) {
        this.toast.error('Error durante la liquidación: ' + e.message);
      } finally {
        this.loading = false;
      }
    },

    // ==================== CARGA DE DATOS ====================
    async cargarDatos() {
      this.loading = true;
      try {
        const res = await obtenerResumenCreditos();
        if (res.success) {
          this.datos = res.data;

          const ventas = this.datos.ventas || [];
          const reparaciones = this.datos.reparaciones || [];
          const serviciosExternos = this.datos.serviciosExternos || [];
          const allItems = [...ventas, ...reparaciones, ...serviciosExternos];
          for (const item of allItems) {
            await this.enriquecerConTelefono(item);
          }
        } else {
          this.toast.error(res.error || 'Error al cargar créditos');
        }
      } catch (e) {
        console.error('Error cargando datos:', e);
        this.toast.error('Error de conexión');
      } finally {
        this.loading = false;
      }
    },

    abrirModalPago(item) {
      this.itemSeleccionado = item;
      this.pagoForm = {
        montoUsd: item.saldo,
        metodoPago: 'Efectivo',
        referencia: '',
        observaciones: ''
      };
      this.showPagoModal = true;
    },

    async procesarPago() {
      if (this.loadingPago) return;
      this.loadingPago = true;

      try {
        let res;
        const idUsuario = localStorage.getItem('idUsuario') || 1;
        const fechaActual = new Date().toISOString();

        if (this.itemSeleccionado.tipo === 'Compra') {
          res = await registrarPagoCompra({
            idCompra: this.itemSeleccionado.id,
            montoUsd: this.pagoForm.montoUsd,
            montoBs: 0,
            tasaBsUsd: 1,
            metodoPago: this.pagoForm.metodoPago,
            referencia: this.pagoForm.referencia,
            idUsuario: idUsuario,
            fechaPago: fechaActual
          });
        } else if (this.itemSeleccionado.tipo === 'Venta') {
          res = await registrarPagoVenta({
            idVenta: this.itemSeleccionado.idVenta || this.itemSeleccionado.id,
            idCuota: this.itemSeleccionado.isCuota ? this.itemSeleccionado.id : null,
            montoUsd: this.pagoForm.montoUsd,
            metodoPago: this.pagoForm.metodoPago,
            referencia: this.pagoForm.referencia,
            idUsuario: idUsuario,
            fechaPago: fechaActual
          });
        } else if (this.itemSeleccionado.tipo === 'Servicio Externo') {
          const { default: apiExternos } = await import('@/api/serviciosExternos.js');
          res = await apiExternos.abonarServicioExterno(
            this.itemSeleccionado.id,
            this.pagoForm.montoUsd,
            this.pagoForm.metodoPago,
            this.pagoForm.referencia,
            fechaActual
          );
        } else {
          res = await registrarPagoReparacion({
            idSalidaEquipoDetalle: this.itemSeleccionado.idSalidaEquipoDetalle || this.itemSeleccionado.id,
            idCuota: this.itemSeleccionado.isCuota ? this.itemSeleccionado.id : null,
            numeroRecibo: `REC-${Date.now()}`,
            montoUsd: this.pagoForm.montoUsd,
            montoBs: 0,
            tasaBsUsd: 1,
            idFuenteTasa: 1,
            idTasaVenta: 1,
            metodoPago: this.pagoForm.metodoPago,
            referencia: this.pagoForm.referencia || "S/R",
            idUsuario: idUsuario,
            estado: "Completado",
            tipoPago: "Abono",
            fechaPago: fechaActual
          });
        }

        if (res.success) {
          this.toast.success('Pago registrado correctamente');
          this.showPagoModal = false;
          await this.cargarDatos();
          if (this.activeTab === 'cashea') {
            await this.cargarPagoSemanalCashea();
          }
        } else {
          this.toast.error(res.error || 'Error al procesar pago');
        }
      } catch (e) {
        this.toast.error('Error interno: ' + e.message);
      } finally {
        this.loadingPago = false;
      }
    },

    formatearFecha(fecha) {
      if (!fecha) return '---';
      return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: 'short' });
    },

    formatearFechaCompleta(fecha) {
      if (!fecha) return '—';
      return new Date(fecha).toLocaleDateString('es-ES', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
      });
    },

    formatearFechaLarga(fecha) {
      if (!fecha) return '';
      return new Date(fecha).toLocaleDateString('es-VE', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    },

    diasTranscurridos(fecha) {
      if (!fecha) return 0;
      const diff = new Date() - new Date(fecha);
      return Math.floor(diff / (1000 * 60 * 60 * 24));
    },

    calcularPorcentajePago(item) {
      if (!item.montoTotal) return 0;
      return ((item.montoTotal - item.saldo) / item.montoTotal) * 100;
    },

    async eliminarRegistro(item) {
      const isReparacion = item.tipo?.toLowerCase() === 'reparación' || item.tipo?.toLowerCase() === 'reparacion';

      const config = {
        title: isReparacion ? '¿Eliminar Reparación Completa?' : '¿Eliminar Cuota de Crédito?',
        message: isReparacion
          ? `Estás a punto de borrar la orden <b>${item.referencia}</b> y TODOS sus pagos y detalles asociados.`
          : `Se eliminará físicamente la cuota de la factura <b>${item.referencia}</b> y sus pagos.`,
        confirmText: 'Sí, eliminar permanentemente',
        type: 'danger'
      };

      this.confirmModal = {
        show: true,
        title: config.title,
        message: config.message + '<br><br><b>Esta acción es irreversible.</b>',
        type: 'danger',
        icon: 'mdi:delete-forever',
        confirmText: config.confirmText,
        callback: async () => {
          this.loading = true;
          try {
            let res;
            if (isReparacion) {
              const { eliminarRecepcion } = await import('@/api/recepcionEquipo.js');
              res = await eliminarRecepcion(item.idRecepcionEquipo || item.id);
            } else {
              const { eliminarCuotaCredito } = await import('@/api/creditoCuotas.js');
              res = await eliminarCuotaCredito(item.id);
            }

            if (res.success) {
              this.toast.success('Registro eliminado correctamente');
              await this.cargarDatos();
            } else {
              this.toast.error(res.error || 'No se pudo eliminar el registro');
            }
          } catch (e) {
            this.toast.error('Error: ' + e.message);
          } finally {
            this.loading = false;
          }
        }
      };
    },

    async abrirDetalles(item) {
      this.detalleSeleccionado = { ...item, fullData: null };
      this.tabActivaDetalle = 'resumen';
      this.modalDetalles.show = true;
      this.modalDetalles.loading = true;

      try {
        if (item.tipo === 'Venta') {
           const res = await obtenerVentaConRelaciones(item.idVenta || item.id);
           if (res.success && res.data) {
             this.detalleSeleccionado.fullData = res.data;
             if (!this.detalleSeleccionado.fullData.vendedorNombre && this.detalleSeleccionado.fullData.idVendedor) {
               this.detalleSeleccionado.fullData.vendedorNombre = this.vendedoresMap.get(this.detalleSeleccionado.fullData.idVendedor) || `Vendedor ${this.detalleSeleccionado.fullData.idVendedor}`;
             }
           }
        } else if (item.tipo === 'Reparación' || item.tipo === 'Reparacion') {
           const idRecepcion = item.idRecepcionEquipo || item.idRecepcion || item.id;
           const res = await obtenerRecepcionConRelaciones(idRecepcion);
           if (res.success && res.data) {
             this.detalleSeleccionado.fullData = res.data;
           }
        } else if (item.tipo === 'Servicio Externo') {
           const { default: apiExternos } = await import('@/api/serviciosExternos.js');
           const res = await apiExternos.obtenerServicioPorId(item.idServicioExterno || item.id);
           if (res.success && res.data) {
             this.detalleSeleccionado.fullData = {
               ...res.data,
               clienteNombre: res.data.nombreCliente || item.entidad,
               nombreTecnicoReparador: res.data.nombreTecnico || 'Sin Asignar',
               montoServiciosUsd: res.data.costo || 0,
               precioTotalUsd: res.data.costo || 0,
               fechaIngreso: res.data.fechaProgramada || res.data.createdAt,
               fechaReparacion: res.data.fechaFinalizacion || null,
               problema: res.data.descripcion || '',
               actividadesRealizadas: res.data.observaciones || 'Sin observaciones'
             };
           }
        }
      } catch(e) {
        console.error(e);
      } finally {
        this.modalDetalles.loading = false;
      }
    },

    cerrarModalDetalles() {
      this.modalDetalles.show = false;
      setTimeout(() => { this.detalleSeleccionado = null; }, 300);
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }

.custom-scrollbar::-webkit-scrollbar { height: 4px; width: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
.animate-fadeInUp { opacity: 0; animation: fadeInUp 0.4s ease-out forwards; }
.animate-zoomIn { animation: zoomIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
.animate-pulse { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }

@media (max-width: 480px) {
  .xs\:inline { display: inline; }
  .xs\:hidden { display: none; }
}

@media (max-width: 1023px) {
  .lg\:hidden { display: block; }
}
@media (min-width: 1024px) {
  .lg\:hidden { display: none; }
  .lg\:block { display: block; }
}

@media print {
  @page { margin: 1cm; size: auto; }
  body { background: white !important; color: black !important; }
  .print\:hidden { display: none !important; }
  .print\:block { display: block !important; }
  .print\:m-0 { margin: 0 !important; }
  .print\:p-0 { padding: 0 !important; }
  .print\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)) !important; }
  .print\:gap-2 { gap: 0.5rem !important; }

  .bg-white, .dark\:bg-gray-800 { background: white !important; }
  .border, .border-gray-200 { border-color: #eee !important; }
  .shadow-sm, .shadow-xl { shadow: none !important; box-shadow: none !important; }
  .text-gray-900, .dark\:text-white, .text-gray-500 { color: black !important; }

  .bg-teal-500, .bg-indigo-500, .bg-emerald-500 {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>